<div
  class="modal panel-meter-modal"
  *ngIf="render_dialog"
  tabindex="-1"
  role="dialog"
  style="display: block"
>
  <div
    class="modal-dialog"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title-carry">
          <h4 class="modal-title">{{ panel_name }} - {{ this.meterName }}</h4>
          <button
            type="button"
            class="btn"
            (click)="closePopup()"
          >
            <img
              src="assets/images/cancel.svg"
              alt="arrow"
            />
          </button>
        </div>
      </div>
      <div class="modal-body">
        <ul
          ngbNav
          #nav="ngbNav"
          [(activeId)]="activeId"
          class="nav-tabs"
        >
          <li
            [ngbNavItem]="1"
            class="panel-meter-menu-tabs quick-set-up-tab-txt"
          >
            <a ngbNavLink>Gateway</a>
            <ng-template ngbNavContent>
              <div class="panel-meter-tab-cont meter-data-tab-data">
                <div
                  style="
                    width: 100%;
                    position: relative;
                    border-radius: 12px;
                    background-color: #fff;
                    box-sizing: border-box;
                    padding: 12px 20px;
                    display: grid;
                    grid-auto-flow: column;
                    gap: 40px;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div
                    style="
                      flex: 1;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: flex-start;
                      gap: 20px;
                    "
                  >
                    <svg
                      [ngStyle]="{
                        fill: gateway == '5' ? '#6285FB' : '#AFB6CE'
                      }"
                      style="cursor: pointer"
                      (click)="gatewayIconClick('5')"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_9159_32116)">
                        <path
                          d="M12.5896 14.2667C12.253 14.2667 11.9802 14.5395 11.9802 14.8761C11.98 16.4535 10.7011 17.732 9.12367 17.7317C7.54628 17.7314 6.26777 16.4525 6.26805 14.8752C6.26833 13.298 7.54694 12.0195 9.12414 12.0195C9.4607 12.0195 9.73352 11.7467 9.73352 11.4102C9.73352 11.0736 9.4607 10.8008 9.12414 10.8008C6.87405 10.8023 5.05037 12.626 5.04883 14.8761C5.04883 17.1267 6.8733 18.9512 9.12391 18.9512C11.3745 18.9512 13.199 17.1267 13.199 14.8761C13.199 14.5395 12.9262 14.2667 12.5896 14.2667Z"
                        />
                        <path
                          d="M17.4309 16.2778C17.3728 15.9463 17.057 15.7246 16.7255 15.7828L15.45 16.0063C15.3357 16.0264 15.2295 16.0786 15.1439 16.1569C15.0583 16.2352 14.9968 16.3363 14.9667 16.4484C14.8307 16.9531 14.6295 17.438 14.3681 17.8907C14.3098 17.9915 14.2815 18.1068 14.2866 18.2231C14.2918 18.3394 14.3302 18.4518 14.3972 18.547L15.1416 19.6078C15.192 19.6793 15.2155 19.7664 15.208 19.8536C15.2004 19.9409 15.1623 20.0226 15.1003 20.0845L14.3353 20.8495C14.2736 20.9114 14.1919 20.9496 14.1048 20.9572C14.0177 20.9648 13.9306 20.9415 13.8591 20.8912L12.7983 20.1468C12.7031 20.0798 12.5907 20.0414 12.4744 20.0363C12.3581 20.0311 12.2428 20.0594 12.142 20.1178C11.6893 20.3792 11.2045 20.5804 10.6997 20.7163C10.5876 20.7465 10.4865 20.8079 10.4082 20.8936C10.3299 20.9792 10.2777 21.0854 10.2577 21.1996L10.0313 22.4737C10.0162 22.5599 9.97127 22.638 9.90429 22.6942C9.83732 22.7505 9.75263 22.7813 9.66516 22.7812H8.58281C8.49535 22.7813 8.41066 22.7505 8.34368 22.6942C8.2767 22.638 8.23174 22.5599 8.21672 22.4737L7.99313 21.1987C7.9731 21.0844 7.92086 20.9782 7.84256 20.8926C7.76425 20.807 7.66314 20.7455 7.5511 20.7154C7.04619 20.5794 6.56117 20.3782 6.10828 20.1168C6.00755 20.0585 5.89221 20.0302 5.77591 20.0353C5.6596 20.0405 5.54721 20.0788 5.45203 20.1459L4.39313 20.8898C4.32156 20.9402 4.23447 20.9638 4.14723 20.9562C4.06 20.9487 3.97825 20.9105 3.91641 20.8485L3.15141 20.0835C3.08955 20.0217 3.05146 19.9401 3.04383 19.853C3.0362 19.7659 3.05952 19.6789 3.10969 19.6073L3.85406 18.5465C3.92109 18.4513 3.95944 18.3389 3.96459 18.2226C3.96974 18.1063 3.94147 17.991 3.88313 17.8903C3.62162 17.4376 3.42038 16.9527 3.28453 16.4479C3.25441 16.3359 3.19294 16.2348 3.10733 16.1564C3.02171 16.0781 2.91553 16.0259 2.80125 16.0059L1.52625 15.7823C1.44024 15.7673 1.36227 15.7225 1.30603 15.6557C1.24979 15.5889 1.21889 15.5044 1.21875 15.4171V14.3348C1.21867 14.2473 1.24947 14.1626 1.30573 14.0957C1.36198 14.0287 1.44008 13.9837 1.52625 13.9687L2.80125 13.7451C2.91553 13.7251 3.02171 13.6728 3.10733 13.5945C3.19294 13.5162 3.25441 13.4151 3.28453 13.3031C3.42027 12.7978 3.62151 12.3124 3.88313 11.8593C3.94147 11.7586 3.96974 11.6432 3.96459 11.5269C3.95944 11.4106 3.92109 11.2983 3.85406 11.2031L3.11016 10.1456C3.05971 10.074 3.03619 9.98691 3.04373 9.89968C3.05128 9.81244 3.08942 9.73069 3.15141 9.66885L3.91688 8.90338C3.97869 8.84151 4.06035 8.80345 4.14748 8.7959C4.23461 8.78836 4.3216 8.81181 4.39313 8.86213L5.45391 9.6065C5.54909 9.67354 5.66148 9.7119 5.77778 9.71705C5.89408 9.7222 6.00943 9.69392 6.11016 9.63557C6.56302 9.37414 7.04805 9.17291 7.55297 9.03697C7.66501 9.00685 7.76613 8.94538 7.84443 8.85977C7.92273 8.77415 7.97497 8.66797 7.995 8.55369L8.2186 7.27869C8.27672 6.94719 8.0551 6.63135 7.7236 6.57322C7.3921 6.5151 7.07625 6.73672 7.01813 7.06822L6.85969 7.97291C6.51215 8.08772 6.17384 8.22875 5.84766 8.39479L5.09531 7.86697C4.46325 7.42222 3.60277 7.49722 3.05719 8.04463L2.28938 8.80729C1.74249 9.35314 1.66772 10.2133 2.11219 10.8454L2.64 11.5978C2.47391 11.9241 2.33288 12.2625 2.21813 12.6103L1.31344 12.7687C0.55322 12.9022 -0.000936193 13.5629 1.30694e-06 14.3348V15.4171C-0.000983068 16.1897 0.554204 16.851 1.31531 16.9837L2.22 17.1426C2.33476 17.4901 2.47579 17.8285 2.64188 18.1546L2.11219 18.907C1.66786 19.5391 1.74281 20.3993 2.28984 20.9451L3.05531 21.7101C3.60108 22.2572 4.46142 22.3319 5.09344 21.8873L5.84344 21.3595C6.16963 21.5255 6.50794 21.6665 6.85547 21.7813L7.01391 22.686C7.14741 23.4475 7.80975 24.0022 8.58281 23.9999H9.66516C10.4379 24.0009 11.0992 23.4455 11.2317 22.6842L11.3906 21.7795C11.7382 21.6647 12.0765 21.5236 12.4027 21.3576L13.1555 21.8854C13.7876 22.33 14.6479 22.255 15.1936 21.7078L15.9591 20.9423C16.5061 20.3965 16.581 19.5363 16.1367 18.9042L15.6094 18.1542C15.7754 17.828 15.9164 17.4897 16.0313 17.1421L16.9359 16.9832C17.2674 16.9251 17.4891 16.6093 17.4309 16.2778Z"
                        />
                        <path
                          d="M22.8561 5.53125L22.2186 5.41969C22.139 5.18983 22.0451 4.96517 21.9374 4.74703L22.3124 4.21875C22.6987 3.66938 22.6336 2.92167 22.1582 2.44735L21.5544 1.84219C21.0799 1.36575 20.331 1.30041 19.7811 1.6875L19.251 2.05922C19.0329 1.9515 18.8082 1.85756 18.5783 1.77797L18.4686 1.14328C18.3532 0.481502 17.7782 -0.00107632 17.1064 1.80287e-06H16.2538C15.5821 -0.000841947 15.0072 0.481971 14.8921 1.14375L14.78 1.78125C14.5502 1.86085 14.3255 1.95478 14.1074 2.0625L13.5772 1.6875C13.0279 1.30116 12.2802 1.36627 11.8058 1.84172L11.203 2.44547C10.7266 2.92003 10.6612 3.66886 11.0483 4.21875L11.42 4.74891C11.3123 4.96703 11.2184 5.19169 11.1388 5.42156L10.5036 5.53125C9.84204 5.64666 9.35951 6.22139 9.36035 6.89297V7.74563C9.35904 8.41753 9.84171 8.99283 10.5036 9.10828L11.1407 9.21985C11.2203 9.44972 11.3142 9.67438 11.4219 9.8925L11.0497 10.4227C10.6633 10.9718 10.728 11.7194 11.203 12.1941L11.8058 12.7969C12.2802 13.2726 13.0282 13.3377 13.5777 12.9511L14.1093 12.5794C14.3274 12.687 14.5521 12.781 14.7819 12.8606L14.8939 13.4981C15.0094 14.1597 15.5841 14.6423 16.2557 14.6414H17.1083C17.7801 14.6414 18.3544 14.1578 18.4686 13.4958L18.5802 12.8588C18.8101 12.7792 19.0347 12.6852 19.2529 12.5775L19.7811 12.9516C20.331 13.3388 21.0799 13.2735 21.5544 12.7969L22.1577 12.1936C22.6329 11.7194 22.6981 10.9721 22.3124 10.4227L21.9397 9.89063C22.0474 9.67249 22.1413 9.44783 22.221 9.21797L22.8585 9.10594C23.5186 8.98988 24 8.41636 23.9999 7.7461V6.89344C24.001 6.22153 23.5181 5.64647 22.8561 5.53125ZM22.7811 7.7475C22.7812 7.78603 22.7676 7.82333 22.7428 7.85283C22.718 7.88232 22.6836 7.90213 22.6457 7.90875L21.6407 8.085C21.5264 8.10503 21.4202 8.15727 21.3346 8.23557C21.249 8.31388 21.1875 8.41499 21.1574 8.52703C21.0531 8.91401 20.8989 9.28574 20.6985 9.63281C20.6401 9.73355 20.6118 9.84889 20.617 9.96519C20.6221 10.0815 20.6605 10.1939 20.7275 10.2891L21.3139 11.1253C21.3361 11.1569 21.3465 11.1952 21.3431 11.2337C21.3398 11.2721 21.323 11.3081 21.2957 11.3353L20.6929 11.9381C20.6653 11.9646 20.6294 11.9806 20.5913 11.9833C20.5532 11.9861 20.5153 11.9754 20.4843 11.9531L19.6466 11.3672C19.5514 11.3002 19.439 11.2618 19.3227 11.2566C19.2064 11.2515 19.0911 11.2798 18.9904 11.3381C18.6433 11.5386 18.2716 11.6928 17.8846 11.797C17.7728 11.8275 17.6719 11.8893 17.594 11.975C17.516 12.0608 17.4641 12.167 17.4444 12.2813L17.2682 13.2863C17.2615 13.3242 17.2417 13.3586 17.2122 13.3834C17.1827 13.4082 17.1454 13.4217 17.1069 13.4217H16.2538C16.2153 13.4217 16.178 13.4082 16.1485 13.3834C16.119 13.3586 16.0992 13.3242 16.0925 13.2863L15.9158 12.2813C15.8958 12.167 15.8436 12.0608 15.7653 11.9752C15.687 11.8896 15.5858 11.8281 15.4738 11.798C15.0867 11.6937 14.7148 11.5395 14.3675 11.3391C14.2668 11.2807 14.1515 11.2524 14.0352 11.2576C13.9189 11.2627 13.8065 11.3011 13.7113 11.3681L12.8774 11.9531C12.8458 11.9753 12.8075 11.9857 12.769 11.9823C12.7306 11.979 12.6946 11.9622 12.6674 11.9348L12.0646 11.332C12.0373 11.3048 12.0204 11.2688 12.0171 11.2304C12.0138 11.1919 12.0241 11.1536 12.0463 11.122L12.6327 10.2858C12.6997 10.1906 12.7381 10.0782 12.7432 9.96191C12.7484 9.84561 12.7201 9.73027 12.6618 9.62953C12.4613 9.2825 12.307 8.91076 12.2029 8.52375C12.1723 8.41201 12.1105 8.31131 12.0247 8.23343C11.939 8.15556 11.8328 8.10374 11.7186 8.08406L10.7136 7.90781C10.6757 7.90119 10.6413 7.88139 10.6165 7.85189C10.5917 7.82239 10.5781 7.78509 10.5782 7.74656L10.5786 6.89344C10.5786 6.85491 10.5922 6.81762 10.617 6.78812C10.6418 6.75862 10.6762 6.73881 10.7141 6.73219L11.7186 6.55547C11.8329 6.53544 11.9391 6.4832 12.0247 6.4049C12.1103 6.3266 12.1718 6.22548 12.2019 6.11344C12.3061 5.72645 12.4604 5.35471 12.6608 5.00766C12.7192 4.90693 12.7475 4.79158 12.7423 4.67528C12.7372 4.55898 12.6988 4.44659 12.6318 4.35141L12.0468 3.51563C12.0246 3.48408 12.0142 3.44571 12.0176 3.40729C12.0209 3.36887 12.0377 3.33286 12.065 3.30563L12.6683 2.70235C12.6956 2.67503 12.7316 2.65822 12.77 2.65487C12.8084 2.65153 12.8468 2.66187 12.8783 2.68406L13.7141 3.27047C13.8093 3.33749 13.9217 3.37585 14.038 3.381C14.1543 3.38615 14.2696 3.35788 14.3704 3.29953C14.7174 3.0991 15.0891 2.94483 15.4761 2.84063C15.5882 2.81051 15.6893 2.74903 15.7676 2.66342C15.8459 2.57781 15.8981 2.47162 15.9182 2.35735L16.0944 1.35235C16.1014 1.31505 16.1211 1.28134 16.1501 1.25697C16.1792 1.2326 16.2159 1.21909 16.2538 1.21875H17.1064C17.145 1.21873 17.1823 1.23231 17.2118 1.25709C17.2413 1.28187 17.2611 1.31627 17.2677 1.35422L17.4439 2.35922C17.464 2.4735 17.5162 2.57968 17.5945 2.66529C17.6728 2.75091 17.7739 2.81238 17.886 2.8425C18.273 2.94665 18.6447 3.10093 18.9918 3.30141C19.0925 3.35977 19.2078 3.38804 19.3241 3.38289C19.4404 3.37774 19.5528 3.33938 19.648 3.27235L20.4843 2.68594C20.5158 2.66374 20.5542 2.6534 20.5926 2.65675C20.631 2.66009 20.667 2.67691 20.6943 2.70422L21.2975 3.3075C21.3241 3.33484 21.3403 3.3706 21.3433 3.40861C21.3463 3.44661 21.3359 3.48446 21.3139 3.51563L20.7275 4.35328C20.6605 4.44846 20.6221 4.56085 20.617 4.67716C20.6118 4.79346 20.6401 4.9088 20.6985 5.00953C20.8989 5.35661 21.0531 5.72834 21.1574 6.11531C21.1875 6.22736 21.249 6.32847 21.3346 6.40678C21.4202 6.48508 21.5264 6.53732 21.6407 6.55735L22.6457 6.7336C22.6836 6.74022 22.718 6.76002 22.7428 6.78952C22.7676 6.81902 22.7812 6.85632 22.7811 6.89485V7.7475Z"
                        />
                        <path
                          d="M16.68 4.40869C15.0721 4.40869 13.7686 5.71219 13.7686 7.3201C13.7704 8.92725 15.0728 10.2297 16.68 10.2315C18.2879 10.2315 19.5914 8.928 19.5914 7.3201C19.5914 5.71219 18.2879 4.40869 16.68 4.40869ZM16.68 9.01275C15.7451 9.01275 14.9873 8.25493 14.9873 7.3201C14.9871 6.3848 15.7447 5.62613 16.68 5.6251V5.62744C17.6148 5.62744 18.3726 6.38527 18.3726 7.3201C18.3726 8.25493 17.6148 9.01275 16.68 9.01275Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_9159_32116">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <svg
                      [ngStyle]="{
                        fill: gateway == '1' ? '#6285FB' : '#AFB6CE'
                      }"
                      style="cursor: pointer"
                      (click)="gatewayIconClick('1')"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.4838 10.3449C9.61757 11.2112 9.61757 12.6146 10.4838 13.4851C11.3501 14.3514 12.7534 14.3514 13.624 13.4851C14.4903 12.6189 14.4903 11.2155 13.624 10.3449C12.7534 9.47868 11.3501 9.47868 10.4838 10.3449ZM16.7599 7.20473C16.3268 6.7716 15.6251 6.7716 15.192 7.20473C14.7589 7.63786 14.7589 8.33954 15.192 8.77267C16.9202 10.5052 16.9202 13.3206 15.192 15.0488C14.7589 15.4819 14.7589 16.1836 15.192 16.6167C15.4085 16.8333 15.6944 16.9415 15.976 16.9415C16.2618 16.9415 16.5434 16.8333 16.7599 16.6167C19.3544 14.0266 19.3544 9.80353 16.7599 7.20473ZM8.91156 7.20473C8.47843 6.7716 7.77676 6.7716 7.34363 7.20473C6.08754 8.46082 5.39453 10.1327 5.39453 11.9129C5.39453 13.6931 6.08754 15.3649 7.34363 16.621C7.56019 16.8376 7.84606 16.9459 8.1276 16.9459C8.41346 16.9459 8.695 16.8376 8.91156 16.621C9.3447 16.1879 9.3447 15.4862 8.91156 15.0531C7.17904 13.3206 7.17904 10.5052 8.91156 8.777C9.34903 8.34387 9.34903 7.6422 8.91156 7.20473Z"
                      />
                      <path
                        d="M19.896 4.06899C19.4629 3.63586 18.7612 3.63586 18.3281 4.06899C17.895 4.50212 17.895 5.2038 18.3281 5.63693C21.7888 9.09765 21.7888 14.7284 18.3281 18.1891C17.895 18.6222 17.895 19.3239 18.3281 19.757C18.5447 19.9736 19.32 20.4371 19.896 19.757C23.8419 15.0835 24.223 8.39598 19.896 4.06899ZM5.77593 5.63693C6.20907 5.2038 6.20907 4.50212 5.77593 4.06899C5.3428 3.63586 4.64113 3.63586 4.20799 4.06899C-0.118997 8.39598 -0.0193763 15.3391 4.20799 19.7614C4.80139 20.3851 5.55937 19.9779 5.77593 19.7614C6.20907 19.3282 6.20907 18.6266 5.77593 18.1934C2.31521 14.7284 2.31521 9.09765 5.77593 5.63693Z"
                      />
                    </svg>

                    <svg
                      [ngStyle]="{
                        fill: gateway == '2' ? '#6285FB' : '#AFB6CE'
                      }"
                      style="cursor: pointer"
                      (click)="gatewayIconClick('2')"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.1658 18.2222C10.1658 17.2444 10.9912 16.4444 12 16.4444C13.0088 16.4444 13.8342 17.2444 13.8342 18.2222C13.8342 19.2 13.0088 20 12 20C10.9912 20 10.1658 19.2 10.1658 18.2222ZM17.8328 14.4533C18.3739 13.9289 18.3739 13.0844 17.8328 12.5689C14.6138 9.44889 9.37705 9.44889 6.15798 12.5689C5.61688 13.0933 5.61688 13.9378 6.15798 14.4533C6.69908 14.9689 7.57034 14.9778 8.10226 14.4533C10.2483 12.3733 13.7425 12.3733 15.8886 14.4533C16.1545 14.7111 16.5122 14.8444 16.8607 14.8444C17.2092 14.8444 17.5669 14.7111 17.8328 14.4533ZM22.5743 10.3022C23.1246 9.79556 23.1429 8.95111 22.6202 8.41778C22.5376 8.33778 22.4551 8.24889 22.3726 8.16889C19.6029 5.48444 15.9161 4 12 4C8.08392 4 4.39712 5.47556 1.62744 8.16C1.5449 8.24 1.46236 8.32889 1.37982 8.40889C0.857061 8.94222 0.875403 9.78667 1.42567 10.2933C1.97594 10.8 2.8472 10.7822 3.36995 10.2489L3.57172 10.0444C5.82782 7.85778 8.81761 6.65778 12 6.65778C15.1824 6.65778 18.1814 7.85778 20.4375 10.0444L20.6392 10.24C20.9052 10.5156 21.272 10.6489 21.6297 10.6489C21.969 10.6489 22.3175 10.5244 22.5835 10.2844L22.5743 10.3022Z"
                      />
                    </svg>

                    <svg
                      [ngStyle]="{
                        fill: gateway == '3' ? '#6285FB' : '#AFB6CE'
                      }"
                      style="cursor: pointer"
                      (click)="gatewayIconClick('3')"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.1244 18.0455L14.2486 3.60204C14.0187 3.17965 13.6791 2.82705 13.2657 2.58138C12.8523 2.33572 12.3803 2.20605 11.8994 2.20605C11.4185 2.20605 10.9465 2.33572 10.5331 2.58138C10.1196 2.82705 9.78011 3.17965 9.5502 3.60204L1.67842 18.0447C1.4567 18.4518 1.34456 18.9095 1.35298 19.3729C1.3614 19.8364 1.4901 20.2897 1.72645 20.6885C1.96281 21.0873 2.29872 21.4178 2.70126 21.6477C3.1038 21.8775 3.55915 21.9989 4.0227 21.9998H19.7761C20.2402 21.9997 20.6963 21.8789 21.0997 21.6493C21.503 21.4196 21.8396 21.089 22.0765 20.6898C22.3134 20.2907 22.4424 19.8368 22.4508 19.3728C22.4592 18.9087 22.3467 18.4505 22.1244 18.043V18.0455ZM20.6706 19.8566C20.5803 20.0135 20.4498 20.1434 20.2926 20.2331C20.1353 20.3228 19.9571 20.369 19.7761 20.3669H4.0227C3.84235 20.3667 3.66514 20.3196 3.50845 20.2303C3.35176 20.141 3.22096 20.0125 3.12887 19.8575C3.03678 19.7024 2.98657 19.526 2.98315 19.3457C2.97973 19.1654 3.02322 18.9873 3.10936 18.8288L10.986 4.38864C11.0755 4.22448 11.2075 4.08745 11.3682 3.99198C11.529 3.89651 11.7124 3.84613 11.8994 3.84613C12.0863 3.84613 12.2698 3.89651 12.4306 3.99198C12.5913 4.08745 12.7233 4.22448 12.8127 4.38864L20.6894 18.8288C20.7779 18.9864 20.8229 19.1646 20.8195 19.3453C20.8162 19.5259 20.7648 19.7025 20.6706 19.8566Z"
                      />
                      <path
                        d="M13.535 12.9236H11.472L12.6592 9.95628C12.6991 9.85652 12.7189 9.7499 12.7175 9.64249C12.7161 9.53508 12.6936 9.429 12.6513 9.33029C12.6089 9.23158 12.5475 9.14219 12.4706 9.06721C12.3937 8.99223 12.3027 8.93313 12.203 8.89329C12.1032 8.85346 11.9966 8.83366 11.8892 8.83503C11.7818 8.8364 11.6757 8.85891 11.577 8.90128C11.4783 8.94364 11.3889 9.00504 11.3139 9.08196C11.2389 9.15887 11.1798 9.2498 11.14 9.34956L9.50464 13.4379C9.45507 13.562 9.43666 13.6964 9.45103 13.8292C9.4654 13.9621 9.5121 14.0894 9.58706 14.2C9.66201 14.3106 9.76293 14.4012 9.88099 14.4637C9.99905 14.5263 10.1306 14.559 10.2643 14.559H12.3273L11.14 17.5263C11.1002 17.6261 11.0804 17.7327 11.0817 17.8401C11.0831 17.9475 11.1056 18.0536 11.148 18.1523C11.2335 18.3517 11.3948 18.5089 11.5963 18.5893C11.7977 18.6698 12.0229 18.6669 12.2222 18.5813C12.4216 18.4958 12.5788 18.3345 12.6592 18.1331L14.2946 14.0447C14.3442 13.9206 14.3626 13.7862 14.3482 13.6534C14.3338 13.5205 14.2871 13.3932 14.2122 13.2826C14.1372 13.172 14.0363 13.0814 13.9183 13.0189C13.8002 12.9563 13.6686 12.9236 13.535 12.9236Z"
                      />
                    </svg>

                    <svg
                      [ngStyle]="{
                        fill: gateway == '4' ? '#6285FB' : '#AFB6CE'
                      }"
                      style="cursor: pointer"
                      (click)="gatewayIconClick('4')"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.7046 11.5402C22.5569 11.3867 22.368 11.2789 22.1607 11.2297C21.9533 11.1805 21.7362 11.1919 21.5352 11.2627C21.3341 11.3335 21.1577 11.4606 21.0269 11.6288C20.8961 11.7971 20.8165 11.9994 20.7975 12.2117C20.6725 13.9188 19.0974 17.8878 16.4645 17.8878C12.8766 16.9339 11.9373 2.76719 6.53436 3.00291C2.03713 3.00291 1.16568 8.40052 1.00139 10.7223C0.98691 11.0103 1.08569 11.2924 1.27659 11.5084C1.46749 11.7244 1.73536 11.8571 2.02286 11.8781C2.31036 11.8991 2.59466 11.8067 2.81493 11.6208C3.0352 11.4348 3.17393 11.17 3.20144 10.8831C3.32644 9.17553 3.90181 5.20688 6.53436 5.20688C7.9451 5.20688 10.1026 9.0541 10.9459 11.8652C12.2137 16.0946 13.4138 20.0918 16.4645 20.0918C20.9653 20.0918 22.8332 14.6942 22.9975 12.3724C23.0076 12.2211 22.9869 12.0693 22.9365 11.9262C22.8862 11.7832 22.8073 11.6518 22.7046 11.5402Z"
                      />
                      <path
                        d="M15.1642 12.2617H18.7857C18.9751 12.2617 19.1568 12.1864 19.2908 12.0525C19.4247 11.9185 19.5 11.7368 19.5 11.5474C19.5 11.3579 19.4247 11.1762 19.2908 11.0423C19.1568 10.9083 18.9751 10.8331 18.7857 10.8331H15.1642C14.9748 10.8331 14.7931 10.9083 14.6591 11.0423C14.5252 11.1762 14.4499 11.3579 14.4499 11.5474C14.4499 11.7368 14.5252 11.9185 14.6591 12.0525C14.7931 12.1864 14.9748 12.2617 15.1642 12.2617ZM8.78302 10.8331H5.16188C4.97244 10.8331 4.79075 10.9083 4.65679 11.0423C4.52284 11.1762 4.44758 11.3579 4.44758 11.5474C4.44758 11.7368 4.52284 11.9185 4.65679 12.0525C4.79075 12.1864 4.97244 12.2617 5.16188 12.2617H8.78338C8.97282 12.2617 9.15451 12.1864 9.28847 12.0525C9.42242 11.9185 9.49768 11.7368 9.49768 11.5474C9.49768 11.3579 9.42242 11.1762 9.28847 11.0423C9.15451 10.9083 8.97247 10.8331 8.78302 10.8331Z"
                      />
                    </svg>

                    <svg
                      [ngStyle]="{
                        fill: gateway == '6' ? '#6285FB' : '#AFB6CE'
                      }"
                      style="cursor: pointer"
                      (click)="gatewayIconClick('6')"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_9841_27346)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.2998 3.30974V0.46875H12.6998V3.30974C13.1473 3.46739 13.5256 3.77194 13.7767 4.1655L18.7451 3.13232C19.5181 2.97158 20.3 3.36418 20.6328 4.08012L22.8995 8.95625H22.992C23.5469 8.95625 23.9967 9.40606 23.9967 9.96094C23.9967 12.3539 22.0568 14.2937 19.6639 14.2937C17.2709 14.2937 15.3311 12.3539 15.3311 9.96094C15.3311 9.40606 15.7809 8.95625 16.3357 8.95625H16.4283L18.4414 4.62543L14.0933 5.5296C14.0037 6.34493 13.4488 7.02018 12.6998 7.28401V19.2687H14.4085C15.5359 19.2687 16.4498 20.1827 16.4498 21.31V22.1281H17.9998V23.5281H6.04668V22.1281H7.59668V21.31C7.59668 20.1827 8.5106 19.2687 9.63796 19.2687H11.2998V7.28401C10.8212 7.11542 10.4218 6.7788 10.1724 6.34499L5.34271 7.34933L7.57135 12.1438H7.66387C8.21874 12.1438 8.66855 12.5936 8.66855 13.1484C8.66855 15.5414 6.72868 17.4813 4.33574 17.4813C1.9428 17.4813 0.00292969 15.5414 0.00292969 13.1484C0.00292969 12.5936 0.452744 12.1438 1.00762 12.1438H1.10014L3.48933 7.00399C3.71572 6.51695 4.15896 6.16554 4.6848 6.05619L9.91912 4.96772C10.0403 4.19586 10.5806 3.56309 11.2998 3.30974ZM2.644 12.1438H6.02749L4.33575 8.50436L2.644 12.1438ZM8.99668 22.1281H15.0498V21.31C15.0498 20.9559 14.7627 20.6688 14.4085 20.6688H9.63796C9.28379 20.6688 8.99668 20.9559 8.99668 21.31V22.1281ZM19.6639 5.31688L17.9721 8.95625H21.3556L19.6639 5.31688ZM11.9998 4.59062C11.6098 4.59062 11.2936 4.90682 11.2936 5.29688C11.2936 5.68693 11.6098 6.00313 11.9998 6.00313C12.3899 6.00313 12.7061 5.68693 12.7061 5.29688C12.7061 4.90682 12.3899 4.59062 11.9998 4.59062ZM16.7575 10.3562C16.9505 11.789 18.1782 12.8938 19.6639 12.8938C21.1495 12.8938 22.3772 11.789 22.5703 10.3562H16.7575ZM1.42934 13.5437C1.62239 14.9765 2.85006 16.0813 4.33574 16.0813C5.82142 16.0813 7.0491 14.9765 7.24214 13.5437H1.42934Z"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_9841_27346">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  <div
                    class="selectMeterContainer"
                    *ngIf="data.panel.secondary_panel"
                  >
                    <div
                      class="selectMeterOption"
                      (click)="handleCurrentDialogPanelIdChange('panel_id')"
                      [style.opacity]="
                        selectedPanelKey === 'panel_id' ? 1 : 0.6
                      "
                    >
                      Main Gateway
                    </div>
                    <div class="selectMeterSeparator"></div>
                    <div
                      class="selectMeterOption"
                      (click)="
                        handleCurrentDialogPanelIdChange('secondary_panel')
                      "
                      [style.opacity]="
                        selectedPanelKey === 'secondary_panel' ? 1 : 0.6
                      "
                    >
                      Support Gateway
                    </div>
                  </div>
                </div>

                <ng-container *ngIf="!isLoading">
                  <div
                    *ngIf="gateway == '5'"
                    class="gatewayContainer"
                  >
                    <div class="gatewayHeaderContainer">
                      <div class="header">Over the Air Updated</div>

                      <div class="radioContainer">
                        <label
                          class="radioLabel"
                          *ngFor="
                            let option of overTheAirUpdateOption;
                            let i = index
                          "
                          (click)="
                            !option.disabled &&
                              (overTheAirUpdateOptionIndex = i)
                          "
                          [ngStyle]="{
                            opacity: option.disabled ? 0.5 : 1,
                            'pointer-events': option.disabled
                              ? 'none'
                              : 'default'
                          }"
                        >
                          <input
                            type="radio"
                            [checked]="i === overTheAirUpdateOptionIndex"
                          />{{ option.label }}
                        </label>
                      </div>
                    </div>

                    <div class="radioContainer subHeader">
                      <label
                        class="radioLabel"
                        *ngFor="let option of setupOption; let i = index"
                        (click)="
                          !option.disabled && (setupOptionSelectionIndex = i)
                        "
                        [ngStyle]="{
                          opacity: option.disabled ? 0.5 : 1,
                          'pointer-events': option.disabled ? 'none' : 'default'
                        }"
                      >
                        <input
                          type="radio"
                          [checked]="i === setupOptionSelectionIndex"
                        />{{ option.label }}
                      </label>
                    </div>

                    <div
                      class="softwareUpdatesContainer"
                      *ngIf="
                        overTheAirUpdateOptionIndex === 0 &&
                        setupOptionSelectionIndex === 0
                      "
                    >
                      <div *ngIf="calibrationStage === 0">
                        <div
                          style="color: #6a7199"
                          class="actionLabel"
                        >
                          Run Pre-Install Calibration
                        </div>

                        <button
                          class="calibrationBtn runBtn"
                          (click)="onRunClick($event, 'noisecheck')"
                        >
                          Run
                        </button>
                      </div>

                      <div *ngIf="calibrationStage === 1">
                        <div
                          style="color: #6a7199"
                          class="actionLabel actionLabelLoading"
                        >
                          <div>Calibrating</div>
                          <div style="position: relative">
                            <div class="dot-elastic"></div>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="calibrationStage === 2">
                        <div
                          style="color: #1fab3d"
                          class="actionLabel"
                        >
                          Calibration Complete
                        </div>

                        <button
                          class="calibrationBtn deleteBtn"
                          (click)="onRunClick($event, 'noisecheck')"
                        >
                          Delete & Restart
                        </button>
                      </div>

                      <div *ngIf="calibrationStage === 3">
                        <div
                          style="color: #6a7199"
                          class="actionLabel"
                        >
                          Calibrate Again
                        </div>

                        <button
                          class="calibrationBtn deleteBtn"
                          (click)="onRunClick($event, 'noisecheck')"
                        >
                          Retry
                        </button>
                      </div>
                    </div>

                    <div
                      class="softwareUpdatesContainer softwareUpdates"
                      *ngIf="setupOptionSelectionIndex === 1"
                    >
                      <div
                        style="
                          background-color: #fff;
                          border-radius: 8px;
                          white-space: nowrap;
                          margin: 16px;
                        "
                        *ngIf="panelDeviceCommands.length > 0"
                      >
                        <div
                          style="display: grid; gap: 20px; padding: 16px"
                          *ngFor="
                            let option of panelDeviceCommands;
                            let i = index
                          "
                        >
                          <div
                            style="
                              display: grid;
                              grid-auto-flow: column;
                              justify-content: space-between;
                              align-items: center;
                              gap: 80px;
                            "
                          >
                            <div
                              style="
                                display: grid;
                                gap: 5px;
                                grid-auto-flow: column;
                                font-size: 15px;
                              "
                            >
                              <div style="color: #0d1758">Created By:</div>
                              <div style="color: rgba(13, 23, 88, 0.6)">
                                {{
                                  option.created_by
                                    ? option.created_by.first_name +
                                      ' ' +
                                      option.created_by.last_name
                                    : '--'
                                }}
                              </div>
                            </div>

                            <div
                              style="
                                display: grid;
                                gap: 40px;
                                grid-auto-flow: column;
                              "
                            >
                              <div>
                                <div style="font-size: 12px; color: #0d1758">
                                  Date Updated:
                                </div>

                                <div
                                  style="
                                    font-size: 10px;
                                    color: rgba(13, 23, 88, 0.6);
                                  "
                                  *ngIf="option.created_at"
                                >
                                  {{
                                    getDate(option.created_at).toLocaleString(
                                      'default',
                                      { month: 'long' }
                                    )
                                  }}/{{
                                    getDate(option.created_at).getDate()
                                  }}/{{
                                    getDate(option.created_at).getFullYear()
                                  }}
                                </div>
                              </div>

                              <div>
                                <div style="font-size: 12px; color: #0d1758">
                                  Time Updated:
                                </div>
                                <div
                                  style="
                                    font-size: 10px;
                                    color: rgba(13, 23, 88, 0.6);
                                  "
                                  *ngIf="option.created_at"
                                >
                                  {{
                                    getDate(
                                      option.created_at
                                    ).toLocaleTimeString()
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            style="width: 100%; border: 1px solid #ece9f1"
                            *ngIf="i !== panelDeviceCommands.length - 1"
                          ></div>
                        </div>
                      </div>

                      <div
                        style="
                          background-color: #fff;
                          border-radius: 8px;
                          white-space: nowrap;
                          margin: 16px;
                        "
                        *ngIf="panelDeviceCommands.length === 0"
                      >
                        <div
                          style="
                            display: grid;
                            place-content: center;
                            padding: 16px;
                            height: 100%;
                            font-size: 24px;
                            color: #0d1758;
                          "
                        >
                          No calibration history
                        </div>
                      </div>
                    </div>

                    <div
                      class="softwareUpdatesContainer softwareUpdates"
                      *ngIf="overTheAirUpdateOptionIndex === 1"
                    >
                      <div
                        style="
                          background-color: #fff;
                          border-radius: 8px;
                          white-space: nowrap;
                          margin: 16px;
                        "
                      >
                        <div style="display: grid; gap: 20px; padding: 16px">
                          <div
                            style="
                              display: grid;
                              grid-auto-flow: column;
                              justify-content: space-between;
                              align-items: center;
                              gap: 80px;
                            "
                          >
                            <div
                              style="
                                display: grid;
                                gap: 5px;
                                grid-auto-flow: column;
                                font-size: 15px;
                              "
                            >
                              <div style="color: #0d1758">Current Version:</div>
                              <div style="color: rgba(13, 23, 88, 0.6)">
                                v1.2.3-g12356-dirty
                              </div>
                            </div>

                            <div
                              style="
                                display: grid;
                                gap: 40px;
                                grid-auto-flow: column;
                              "
                            >
                              <div>
                                <div style="font-size: 12px; color: #0d1758">
                                  Date Updated:
                                </div>
                                <div
                                  style="
                                    font-size: 10px;
                                    color: rgba(13, 23, 88, 0.6);
                                  "
                                >
                                  Nov/22/2023
                                </div>
                              </div>

                              <div>
                                <div style="font-size: 12px; color: #0d1758">
                                  Time Updated:
                                </div>
                                <div
                                  style="
                                    font-size: 10px;
                                    color: rgba(13, 23, 88, 0.6);
                                  "
                                >
                                  22:12:54
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            style="
                              display: grid;
                              grid-auto-flow: column;
                              align-items: center;
                              justify-content: start;
                              gap: 40px;
                            "
                          >
                            <div>
                              <div style="font-size: 12px; color: #0d1758">
                                File Name:
                              </div>
                              <div
                                style="
                                  font-size: 10px;
                                  color: rgba(13, 23, 88, 0.6);
                                "
                              >
                                fw-esp32.bin
                              </div>
                            </div>

                            <div>
                              <div style="font-size: 12px; color: #0d1758">
                                md5 hash:
                              </div>
                              <div
                                style="
                                  font-size: 10px;
                                  color: rgba(13, 23, 88, 0.6);
                                "
                              >
                                28f34316d3f0caef8bfb6419edb84665
                              </div>
                            </div>

                            <div>
                              <div style="font-size: 12px; color: #0d1758">
                                Version String:
                              </div>
                              <div
                                style="
                                  font-size: 10px;
                                  color: rgba(13, 23, 88, 0.6);
                                "
                              >
                                v0.0.1-25-ge9c7e1d-dirty
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          style="
                            width: calc(100% - 32px);
                            border: 1px solid #ece9f1;
                            margin-left: 16px;
                          "
                        ></div>

                        <div style="display: grid; gap: 20px; padding: 16px">
                          <div
                            style="
                              display: grid;
                              grid-auto-flow: column;
                              justify-content: space-between;
                              align-items: center;
                              gap: 80px;
                            "
                          >
                            <div
                              style="
                                display: grid;
                                gap: 5px;
                                grid-auto-flow: column;
                                font-size: 15px;
                              "
                            >
                              <div style="color: #0d1758">Current Version:</div>
                              <div style="color: rgba(13, 23, 88, 0.6)">
                                v1.2.3-g12356-dirty
                              </div>
                            </div>

                            <div
                              style="
                                display: grid;
                                gap: 40px;
                                grid-auto-flow: column;
                              "
                            >
                              <div>
                                <div style="font-size: 12px; color: #0d1758">
                                  Date Updated:
                                </div>
                                <div
                                  style="
                                    font-size: 10px;
                                    color: rgba(13, 23, 88, 0.6);
                                  "
                                >
                                  Nov/22/2023
                                </div>
                              </div>

                              <div>
                                <div style="font-size: 12px; color: #0d1758">
                                  Time Updated:
                                </div>
                                <div
                                  style="
                                    font-size: 10px;
                                    color: rgba(13, 23, 88, 0.6);
                                  "
                                >
                                  22:12:54
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            style="
                              display: grid;
                              grid-auto-flow: column;
                              align-items: center;
                              justify-content: start;
                              gap: 40px;
                            "
                          >
                            <div>
                              <div style="font-size: 12px; color: #0d1758">
                                File Name:
                              </div>
                              <div
                                style="
                                  font-size: 10px;
                                  color: rgba(13, 23, 88, 0.6);
                                "
                              >
                                fw-esp32.bin
                              </div>
                            </div>

                            <div>
                              <div style="font-size: 12px; color: #0d1758">
                                md5 hash:
                              </div>
                              <div
                                style="
                                  font-size: 10px;
                                  color: rgba(13, 23, 88, 0.6);
                                "
                              >
                                28f34316d3f0caef8bfb6419edb84665
                              </div>
                            </div>

                            <div>
                              <div style="font-size: 12px; color: #0d1758">
                                Version String:
                              </div>
                              <div
                                style="
                                  font-size: 10px;
                                  color: rgba(13, 23, 88, 0.6);
                                "
                              >
                                v0.0.1-25-ge9c7e1d-dirty
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="gateway == '6'"
                    class="gatewayContainer"
                  >
                    <div class="loadBalancingHeader">
                      <div class="header">Load Balancing</div>

                      <div class="subHeader">
                        How will the Load be Balanced for this panel?
                      </div>
                    </div>

                    <div class="loadBalancingOptions">
                      <div
                        *ngFor="let option of loadBalancingOptions"
                        class="loadBalancingOption"
                        [style.borderColor]="
                          option.isSelected() ? '#6285FB' : '#ece9f1'
                        "
                        (click)="option.onChange()"
                      >
                        <label class="radioLabel"
                          ><input
                            type="radio"
                            [checked]="option.isSelected()"
                            (change)="option.onChange()"
                          /><span>{{ option.label }}</span></label
                        >

                        <img src="{{ option.src }}" />

                        <div>{{ option.subLabel }}</div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="gateway == '1'"
                    style="
                      width: 100%;
                      height: 466px;
                      padding-top: 24px;
                      background: #f5f5f5;
                      border-top-left-radius: 8px;
                      border-top-right-radius: 8px;
                      border-bottom-right-radius: 8px;
                      overflow: hidden;
                      flex-direction: column;
                      justify-content: flex-start;
                      align-items: flex-start;
                      gap: 18px;
                      display: inline-flex;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        flex: 1 1 0;
                        padding: 20px;
                        background: white;
                        border-radius: 8px;
                        flex-direction: column;
                        justify-content: flex-start;
                        align-items: flex-start;
                        gap: 20px;
                        display: flex;
                      "
                    >
                      <div
                        style="
                          align-self: stretch;
                          height: 65px;
                          flex-direction: column;
                          justify-content: flex-start;
                          align-items: flex-start;
                          gap: 12px;
                          display: flex;
                        "
                      >
                        <div
                          style="
                            align-self: stretch;
                            height: 52px;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: flex-end;
                            gap: 6px;
                            display: flex;
                          "
                        >
                          <div
                            style="
                              align-self: stretch;
                              color: #0d1758;
                              font-size: 22px;
                              font-weight: 700;
                              word-wrap: break-word;
                            "
                          >
                            Live Usage
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              color: rgba(13, 23, 88, 0.6);
                              font-size: 15px;
                              font-weight: 600;
                              word-wrap: break-word;
                            "
                          >
                            Live readings from Gateway
                          </div>
                        </div>
                        <div
                          style="
                            align-self: stretch;
                            height: 1px;
                            background: #ece9f1;
                          "
                        ></div>
                      </div>
                      <div
                        style="
                          align-self: stretch;
                          justify-content: flex-start;
                          align-items: flex-start;
                          gap: 80px;
                          display: inline-flex;
                        "
                      >
                        <div
                          style="
                            flex: 1 1 0;
                            align-self: stretch;
                            border-radius: 8px;
                            justify-content: flex-start;
                            align-items: center;
                            gap: 80px;
                            display: flex;
                          "
                        >
                          <div
                            style="
                              flex: 1 1 0;
                              color: #0d1758;
                              font-size: 17px;
                              font-weight: 600;
                              word-wrap: break-word;
                            "
                          >
                            Network:
                          </div>
                          <div
                            style="
                              flex: 1 1 0;
                              text-align: right;
                              color: rgba(13, 23, 88, 0.6);
                              font-size: 15px;
                              font-weight: 600;
                              word-wrap: break-word;
                            "
                          >
                            {{ network }}
                          </div>
                        </div>
                        <div
                          style="
                            flex: 1 1 0;
                            align-self: stretch;
                            border-radius: 8px;
                            justify-content: flex-start;
                            align-items: center;
                            gap: 80px;
                            display: flex;
                          "
                        >
                          <div
                            style="
                              flex: 1 1 0;
                              color: #0d1758;
                              font-size: 17px;
                              font-weight: 600;
                              word-wrap: break-word;
                            "
                          >
                            Connected:
                          </div>
                          <div
                            style="
                              flex: 1 1 0;
                              height: 19px;
                              justify-content: flex-end;
                              align-items: center;
                              gap: 12px;
                              display: flex;
                              text-transform: capitalize;
                            "
                          >
                            <div
                              style="
                                color: rgba(13, 23, 88, 0.6);
                                font-size: 15px;
                                font-weight: 600;
                                word-wrap: break-word;
                              "
                            >
                              {{ connectivity }}
                            </div>
                            <div
                              style="
                                padding-left: 8px;
                                padding-right: 8px;
                                padding-top: 4px;
                                padding-bottom: 4px;
                                border-radius: 100px;
                                border: 1px solid;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 10px;
                                display: flex;
                              "
                              [ngStyle]="{
                                'border-color': !isPanelConnected
                                  ? 'red'
                                  : '#22B14C'
                              }"
                            >
                              <div
                                style="
                                  font-size: 9px;
                                  font-weight: 700;
                                  word-wrap: break-word;
                                "
                              >
                                {{ !isPanelConnected ? 'Offline' : 'Online' }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style="
                          align-self: stretch;
                          height: 1px;
                          background: #ece9f1;
                        "
                      ></div>
                      <div
                        style="
                          align-self: stretch;
                          justify-content: flex-start;
                          align-items: flex-start;
                          gap: 80px;
                          display: inline-flex;
                        "
                      >
                        <div
                          style="
                            flex: 1 1 0;
                            border-radius: 8px;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: flex-start;
                            gap: 12px;
                            display: inline-flex;
                          "
                        >
                          <div
                            style="
                              align-self: stretch;
                              color: #0d1758;
                              font-size: 17px;
                              font-weight: 600;
                              word-wrap: break-word;
                            "
                          >
                            Current/Amps:
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              height: 91px;
                              flex-direction: column;
                              justify-content: flex-start;
                              align-items: flex-start;
                              gap: 8px;
                              display: flex;
                            "
                          >
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port I1
                              </div>
                              <div style="flex: 1 1 0; text-align: right">
                                <span
                                  style="
                                    font-size: 20px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  [style.color]="
                                    selectedCurrentCtClamp !== 'null'
                                      ? '#0d1758'
                                      : '#ED1C24'
                                  "
                                  >{{ currentSectionList[0] }}</span
                                ><span
                                  *ngIf="selectedCurrentCtClamp !== 'null'"
                                  style="
                                    color: #0d1758;
                                    font-size: 15px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  >A</span
                                >
                              </div>
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port I2
                              </div>
                              <div style="text-align: right">
                                <span
                                  style="
                                    font-size: 20px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  [style.color]="
                                    selectedCurrentCtClamp2 !== 'null'
                                      ? '#0d1758'
                                      : '#ED1C24'
                                  "
                                  >{{ currentSectionList[1] }}</span
                                ><span
                                  *ngIf="selectedCurrentCtClamp2 !== 'null'"
                                  style="
                                    color: #0d1758;
                                    font-size: 15px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  >A</span
                                >
                              </div>
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port I3
                              </div>
                              <div style="flex: 1 1 0; text-align: right">
                                <span
                                  style="
                                    font-size: 20px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  [style.color]="
                                    selectedCurrentCtClamp3 !== 'null'
                                      ? '#0d1758'
                                      : '#ED1C24'
                                  "
                                  >{{ currentSectionList[2] }}</span
                                ><span
                                  *ngIf="selectedCurrentCtClamp3 !== 'null'"
                                  style="
                                    color: #0d1758;
                                    font-size: 15px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  >A</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style="
                            flex: 1 1 0;
                            border-radius: 8px;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: flex-start;
                            gap: 12px;
                            display: inline-flex;
                          "
                        >
                          <div
                            style="
                              align-self: stretch;
                              color: #0d1758;
                              font-size: 17px;
                              font-weight: 600;
                              word-wrap: break-word;
                            "
                          >
                            Voltage
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              height: 91px;
                              flex-direction: column;
                              justify-content: flex-start;
                              align-items: flex-start;
                              gap: 8px;
                              display: flex;
                            "
                          >
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port V1
                              </div>
                              <div style="flex: 1 1 0; text-align: right">
                                <span
                                  style="
                                    font-size: 20px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  [style.color]="
                                  !!voltage_transformers?.['V1'] ? '#0d1758' : '#ED1C24'
                                "
                                  >{{ !!voltage_transformers?.['V1'] ? voltageSectionList[0] : EMPTY_PORT }}</span
                                ><span
                                  *ngIf="!!voltage_transformers?.['V1']"
                                  style="
                                    color: #0d1758;
                                    font-size: 15px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  >V</span
                                >
                              </div>
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port V2
                              </div>
                              <div style="flex: 1 1 0; text-align: right">
                                <span
                                  style="
                                    font-size: 20px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  [style.color]="
                                  !!voltage_transformers?.['V2'] ? '#0d1758' : '#ED1C24'
                                "
                                  >{{ !!voltage_transformers?.['V2'] ? voltageSectionList[1] : EMPTY_PORT }}</span
                                ><span
                                  *ngIf="!!voltage_transformers?.['V2']"
                                  style="
                                    color: #0d1758;
                                    font-size: 15px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  >V</span
                                >
                              </div>
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port V3
                              </div>
                              <div style="flex: 1 1 0; text-align: right">
                                <span
                                  style="
                                    font-size: 20px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  [style.color]="
                                  !!voltage_transformers?.['V3'] ? '#0d1758' : '#ED1C24'
                                "
                                  >{{ !!voltage_transformers?.['V3'] ? voltageSectionList[2] : EMPTY_PORT }}</span
                                ><span
                                  *ngIf="!!voltage_transformers?.['V3']"
                                  style="
                                    color: #0d1758;
                                    font-size: 15px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  >V</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="gateway == '2'"
                    style="
                      width: 100%;
                      height: 466px;
                      padding-top: 24px;
                      background: #f5f5f5;
                      border-top-left-radius: 8px;
                      border-top-right-radius: 8px;
                      border-bottom-right-radius: 8px;
                      overflow: hidden;
                      flex-direction: column;
                      justify-content: flex-start;
                      align-items: flex-start;
                      gap: 18px;
                      display: inline-flex;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        flex: 1 1 0;
                        padding: 20px;
                        background: white;
                        border-radius: 8px;
                        flex-direction: column;
                        justify-content: flex-start;
                        align-items: flex-start;
                        gap: 20px;
                        display: flex;
                      "
                    >
                      <div
                        style="
                          align-self: stretch;
                          height: 65px;
                          flex-direction: column;
                          justify-content: flex-start;
                          align-items: flex-start;
                          gap: 12px;
                          display: flex;
                        "
                      >
                        <div
                          style="
                            align-self: stretch;
                            height: 52px;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: flex-end;
                            gap: 6px;
                            display: flex;
                          "
                        >
                          <div
                            style="
                              align-self: stretch;
                              color: #0d1758;
                              font-size: 22px;
                              font-weight: 700;
                              word-wrap: break-word;
                            "
                          >
                            Connectivity
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              color: rgba(13, 23, 88, 0.6);
                              font-size: 15px;
                              font-weight: 600;
                              word-wrap: break-word;
                            "
                          >
                            How will this gateway be connected?
                          </div>
                        </div>
                        <div
                          style="
                            align-self: stretch;
                            height: 1px;
                            background: #ece9f1;
                          "
                        ></div>
                      </div>

                      <div class="connectivityContents">
                        <div>
                          <div
                            style="
                              color: #0d1758;
                              font-size: 15;
                              font-weight: 500;
                            "
                          >
                            Meter Name:
                          </div>

                          <input
                            class="connectivityOptionsBox"
                            style="
                              color: #0d1758;
                              margin-top: 16px;
                              pointer-events: unset;
                            "
                            type="text"
                            id="meter-name"
                            value="{{ panel_expansions.meter_name }}"
                            name="meter-name"
                          />

                          <ul
                            class="radioContainer connectivityOptionsContainer"
                          >
                            <li
                              *ngFor="
                                let option of connectivityOptions;
                                let i = index
                              "
                              class="connectivityOptionsBox"
                              [style.borderColor]="
                                option.isSelected() && '#6285FB'
                              "
                              style="pointer-events: none"
                            >
                              <label class="radioLabel"
                                ><input
                                  type="radio"
                                  [checked]="option.isSelected()"
                                /><span
                                  [style.color]="
                                    option.isSelected()
                                      ? 'inherit'
                                      : 'rgba(13, 23, 88, 0.6)'
                                  "
                                  >{{ option.label }}</span
                                ></label
                              >
                            </li>
                          </ul>
                        </div>

                        <div
                          class="wifiStrengthContainer"
                          *ngIf="connectivity === 'wifi'"
                        >
                          <div
                            style="
                              color: #0d1758;
                              font-size: 19px;
                              margin-bottom: 16px;
                            "
                          >
                            Wifi Signal Strength
                          </div>

                          <div class="wifiStrengthValueContainer">
                            <svg
                              width="80"
                              height="80"
                              viewBox="0 0 80 80"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M78.7492 26.0147C57.3799 4.66176 22.6201 4.66176 1.25077 26.0147C-0.416922 27.6824 -0.416922 30.3965 1.25077 32.0805C2.91845 33.7482 5.63254 33.7482 7.31658 32.0805C25.3342 14.0466 54.6658 14.0466 72.6998 32.0805C73.5336 32.9144 74.6291 33.3395 75.7245 33.3395C76.8199 33.3395 77.9154 32.9144 78.7492 32.0805C80.4169 30.4128 80.4169 27.6988 78.7492 26.0147Z"
                                [attr.fill]="
                                  wifiPower.wifiStrength >= 3
                                    ? wifiPower.fill
                                    : '#ECE9F1'
                                "
                              />
                              <path
                                d="M13.0066 37.7868C11.3389 39.4545 11.3389 42.1686 13.0066 43.8526C14.6743 45.5203 17.3884 45.5203 19.0724 43.8526C30.6155 32.3096 49.4015 32.3096 60.9445 43.8526C61.7783 44.6864 62.8738 45.1115 63.9692 45.1115C65.0647 45.1115 66.1601 44.6864 66.994 43.8526C68.6616 42.1849 68.6616 39.4708 66.994 37.7868C52.1156 22.892 27.885 22.892 13.0066 37.7868Z"
                                [attr.fill]="
                                  wifiPower.wifiStrength >= 2
                                    ? wifiPower.fill
                                    : '#ECE9F1'
                                "
                              />
                              <path
                                d="M24.5818 49.3622C22.9141 51.0299 22.9141 53.744 24.5818 55.428C26.2495 57.0957 28.9636 57.0957 30.6476 55.428C35.7978 50.2615 44.2017 50.2615 49.3519 55.428C50.1857 56.2619 51.2812 56.687 52.3766 56.687C53.4721 56.687 54.5675 56.2619 55.4014 55.428C57.069 53.7603 57.069 51.0462 55.4014 49.3786C46.9158 40.8603 33.0838 40.8603 24.5818 49.3622Z"
                                [attr.fill]="
                                  wifiPower.wifiStrength >= 1
                                    ? wifiPower.fill
                                    : '#ECE9F1'
                                "
                              />
                              <path
                                d="M40.001 70.4698C43.1524 70.4698 45.7071 67.9151 45.7071 64.7637C45.7071 61.6123 43.1524 59.0576 40.001 59.0576C36.8496 59.0576 34.2949 61.6123 34.2949 64.7637C34.2949 67.9151 36.8496 70.4698 40.001 70.4698Z"
                                [attr.fill]="
                                  wifiPower.wifiStrength >= 0
                                    ? wifiPower.fill
                                    : '#ECE9F1'
                                "
                              />
                            </svg>

                            <div>
                              <div style="font-size: 20px">
                                {{ wifiPower.value }}
                              </div>
                              <div style="line-height: 0.7">dBm</div>
                            </div>
                          </div>

                          <div
                            [style.color]="wifiPower.fill"
                            style="font-size: 19px"
                          >
                            {{ wifiPower.text }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="gateway == '3'"
                    style="
                      width: 100%;
                      height: 466px;
                      padding-top: 24px;
                      background: #f5f5f5;
                      border-top-left-radius: 8px;
                      border-top-right-radius: 8px;
                      border-bottom-right-radius: 8px;
                      overflow: hidden;
                      flex-direction: column;
                      justify-content: flex-start;
                      align-items: flex-start;
                      gap: 18px;
                      display: inline-flex;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        flex: 1 1 0;
                        padding: 20px;
                        background: white;
                        border-radius: 8px;
                        flex-direction: column;
                        justify-content: flex-start;
                        align-items: flex-start;
                        display: flex;
                      "
                    >
                      <div class="headerContainer">
                        <span
                          style="
                            align-self: stretch;
                            color: #0d1758;
                            font-size: 22px;
                            font-weight: 700;
                            word-wrap: break-word;
                          "
                          >Voltage</span
                        >
                        <ul class="radioContainer voltageParent">
                          <li *ngFor="let x of voltageOptions; let i = index">
                            <label
                              class="radioLabel"
                              (click)="selectedVoltageOption = i"
                              ><input
                                type="radio"
                                [checked]="i === selectedVoltageOption"
                              /><span>{{ x.label }}</span></label
                            >
                          </li>
                        </ul>
                      </div>

                      <ng-container *ngIf="selectedVoltageOption === 0">
                        <div class="voltageLiveReadings">
                          <div *ngFor="let x of liveVoltageReadings">
                            <div style="font-size: 19px; color: #6e749b">
                              {{ x.label }}
                            </div>
                            <div
                              [style.color]="
                                x.isActive() ? '#0d1758' : '#ED1C24'
                              "
                              style="font-size: 24px"
                            >
                              {{ x.isActive() ? x.value() : EMPTY_PORT
                              }}<span
                                style="font-size: 20px"
                                *ngIf="x.isActive()"
                                >v</span
                              >
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="selectedVoltageOption === 1">
                        <div class="sourceAndMapping">
                          <div class="sourceAndMappingOptions">
                            <div
                              *ngFor="let x of sourceAndMapping; let i = index"
                              (click)="handleSourceAndMappingChange(i)"
                              class="sourceAndMappingOption"
                              [ngClass]="{
                                activeSourceAndMappingOption:
                                  i === selectedSourceAndMapping
                              }"
                            >
                              <div>
                                <label
                                  class="radioLabel sourceAndMappingOptionInput"
                                  ><input
                                    type="radio"
                                    [checked]="i === selectedSourceAndMapping"
                                  /><span>{{ x.label }}:</span></label
                                >
                              </div>

                              <ng-container *ngIf="x.type === 'select'">
                                <div *ngFor="let y of x.fields">
                                  <div
                                    *ngIf="y.label"
                                    style="
                                      color: #0d1758;
                                      font-size: 11px;
                                      margin-left: 21px;
                                    "
                                  >
                                    {{ y.label }}:
                                  </div>

                                  <select
                                    style="
                                      margin-left: 21px;
                                      width: calc(100% - 21px);
                                      color: #6e749b;
                                      border: none;
                                      border-bottom: 1px solid #ece9f1;
                                      padding-bottom: 6px;
                                      outline: none;
                                    "
                                    [style.pointerEvents]="
                                      i === selectedSourceAndMapping
                                        ? 'all'
                                        : 'none'
                                    "
                                    [disabled]="i !== selectedSourceAndMapping"
                                    (change)="y.change($event)"
                                  >
                                    <option
                                      *ngFor="let z of y.options()"
                                      value="{{ z.value }}"
                                      [disabled]="z.disabled"
                                      [selected]="y.value() === z.value"
                                    >
                                      {{ z.label }}
                                    </option>
                                  </select>
                                </div>
                              </ng-container>

                              <div
                                *ngIf="x.type === 'text'"
                                style="position: relative"
                                [class.artificalVoltageInputDisabled]="
                                  selectedSourceAndMapping !== 1
                                "
                              >
                                <input
                                  type="text"
                                  style="
                                    margin-left: 21px;
                                    width: calc(100% - 21px);
                                    color: #6e749b;
                                    border: none;
                                    border-bottom: 1px solid #ece9f1;
                                    outline: none;
                                    text-align: right;
                                    padding-right: 30px;
                                    font-size: 14px;
                                  "
                                  [disabled]="
                                    isArtificalVoltageEditing === false
                                  "
                                  class="artificalVoltageInput"
                                  id="artificalVoltageInput"
                                  [value]="artificalVoltageValue()"
                                />

                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                  class="editSvg"
                                  (click)="isArtificalVoltageEditing = true"
                                  *ngIf="isArtificalVoltageEditing === false"
                                >
                                  <g clip-path="url(#clip0_9410_16744)">
                                    <path
                                      d="M13.641 7.91746C13.244 7.91746 12.9231 8.23916 12.9231 8.63537V14.379C12.9231 14.7746 12.6014 15.0969 12.2052 15.0969H2.15385C1.7575 15.0969 1.43594 14.7746 1.43594 14.379V4.32767C1.43594 3.93211 1.7575 3.60977 2.15385 3.60977H7.89748C8.2945 3.60977 8.61539 3.28811 8.61539 2.89187C8.61539 2.49553 8.2945 2.17383 7.89748 2.17383H2.15385C0.96637 2.17383 0 3.1402 0 4.32767V14.379C0 15.5665 0.96637 16.5328 2.15385 16.5328H12.2052C13.3926 16.5328 14.359 15.5665 14.359 14.379V8.63537C14.359 8.23839 14.038 7.91746 13.641 7.91746Z"
                                      fill="#0D1758"
                                    />
                                    <path
                                      d="M5.53672 8.46078C5.48682 8.5109 5.45264 8.57451 5.43838 8.64379L4.93082 11.1826C4.90716 11.3002 4.94448 11.4215 5.02915 11.507C5.06257 11.5403 5.10222 11.5667 5.14584 11.5847C5.18946 11.6027 5.23619 11.6119 5.28337 11.6118C5.30626 11.6118 5.33005 11.6097 5.35371 11.6047L7.89168 11.0971C7.96202 11.0826 8.02589 11.049 8.07546 10.9986L13.7559 5.31821L11.2179 2.78038L5.53672 8.46078ZM15.5105 1.02503C14.8106 0.324992 13.6719 0.324992 12.9725 1.02503L11.9789 2.01859L14.5169 4.55656L15.5105 3.56286C15.8494 3.22474 16.036 2.77381 16.036 2.29425C16.036 1.81468 15.8494 1.36378 15.5105 1.02503Z"
                                      fill="#0D1758"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_9410_16744">
                                      <rect
                                        width="16"
                                        height="16"
                                        fill="white"
                                        transform="translate(0 0.5)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>

                                <svg
                                  width="16"
                                  height="17"
                                  viewBox="0 0 24 24"
                                  fill="white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="editSvg"
                                  (click)="handleArtificalVolatageSave()"
                                  *ngIf="isArtificalVoltageEditing === true"
                                >
                                  <path
                                    d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                    fill="green"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>

                          <div class="sourceAndMappingPortsContainer">
                            <div
                              *ngFor="let x of sourceAndMappingPorts"
                              class="sourceAndMappingPorts"
                            >
                              <div style="color: #0d1758; font-size: 19px">
                                {{ x.label }}
                              </div>

                              <select
                                *ngIf="
                                  referencePanels.length === 0 || x.isActive()
                                "
                                style="
                                  width: calc(100% + 21px);
                                  color: #6e749b;
                                  border: none;
                                  border-bottom: 1px solid #ece9f1;
                                  padding-bottom: 6px;
                                  outline: none;
                                  font-size: 19px;
                                "
                                (change)="
                                  handleSourceMappingPortsValueChange(
                                    $event,
                                    x.id
                                  )
                                "
                                class="selectDisabled"
                                [disabled]="referencePanels.length > 0"
                              >
                                <option
                                  *ngFor="let y of transformerOptions"
                                  value="{{ y.value }}"
                                  [disabled]="y.disabled"
                                  [selected]="x.value() === y.value"
                                >
                                  {{ y.label }}
                                </option>
                              </select>

                              <div
                                *ngIf="
                                  referencePanels.length > 0 && !x.isActive()
                                "
                                style="color: #ed1c24; font-size: 19px"
                              >
                                Empty Port
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="selectedVoltageOption === 2">
                        <div class="customizeCoefficient">
                          <div class="portCoefficientContainer">
                            <div *ngFor="let x of portCoefficient">
                              <div>
                                <div style="color: #0d1758; font-size: 19px">
                                  {{ x.label }}
                                </div>

                                <div
                                  *ngIf="x.isActive()"
                                  style="
                                    color: #6a7199;
                                    font-size: 12px;
                                    white-space: nowrap;
                                  "
                                >
                                  {{ x.subLabel() }}
                                </div>

                                <div
                                  *ngIf="!x.isActive()"
                                  style="color: #ed1c24; font-size: 12px"
                                >
                                  Empty Port
                                </div>
                              </div>

                              <div
                                *ngIf="x.isActive()"
                                class="portCoefficientEditableFieldsContainer"
                              >
                                <ng-container
                                  *ngIf="isPortsCoefficientEditing !== x.id"
                                >
                                  <div style="color: #6a7199; font-size: 19px">
                                    {{ x.value() }}
                                  </div>

                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="17"
                                    viewBox="0 0 16 17"
                                    fill="none"
                                    (click)="
                                      togglePortsCofficientEdit(x.id, x.value())
                                    "
                                    style="cursor: pointer"
                                    [ngClass]="{
                                      svg_disabled:
                                        isPortsCoefficientEditing !== null &&
                                        isPortsCoefficientEditing !== x.id
                                    }"
                                  >
                                    <g clip-path="url(#clip0_9410_16744)">
                                      <path
                                        d="M13.641 7.91746C13.244 7.91746 12.9231 8.23916 12.9231 8.63537V14.379C12.9231 14.7746 12.6014 15.0969 12.2052 15.0969H2.15385C1.7575 15.0969 1.43594 14.7746 1.43594 14.379V4.32767C1.43594 3.93211 1.7575 3.60977 2.15385 3.60977H7.89748C8.2945 3.60977 8.61539 3.28811 8.61539 2.89187C8.61539 2.49553 8.2945 2.17383 7.89748 2.17383H2.15385C0.96637 2.17383 0 3.1402 0 4.32767V14.379C0 15.5665 0.96637 16.5328 2.15385 16.5328H12.2052C13.3926 16.5328 14.359 15.5665 14.359 14.379V8.63537C14.359 8.23839 14.038 7.91746 13.641 7.91746Z"
                                        fill="#0D1758"
                                      />
                                      <path
                                        d="M5.53672 8.46078C5.48682 8.5109 5.45264 8.57451 5.43838 8.64379L4.93082 11.1826C4.90716 11.3002 4.94448 11.4215 5.02915 11.507C5.06257 11.5403 5.10222 11.5667 5.14584 11.5847C5.18946 11.6027 5.23619 11.6119 5.28337 11.6118C5.30626 11.6118 5.33005 11.6097 5.35371 11.6047L7.89168 11.0971C7.96202 11.0826 8.02589 11.049 8.07546 10.9986L13.7559 5.31821L11.2179 2.78038L5.53672 8.46078ZM15.5105 1.02503C14.8106 0.324992 13.6719 0.324992 12.9725 1.02503L11.9789 2.01859L14.5169 4.55656L15.5105 3.56286C15.8494 3.22474 16.036 2.77381 16.036 2.29425C16.036 1.81468 15.8494 1.36378 15.5105 1.02503Z"
                                        fill="#0D1758"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_9410_16744">
                                        <rect
                                          width="16"
                                          height="16"
                                          fill="white"
                                          transform="translate(0 0.5)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </ng-container>

                                <ng-container
                                  *ngIf="isPortsCoefficientEditing === x.id"
                                >
                                  <input
                                    type="text"
                                    value="{{
                                      portsCoefficientEditedValue[x.id]
                                    }}"
                                    (input)="
                                      handlePortsCoefficientValueChange(
                                        $event,
                                        x.id
                                      )
                                    "
                                    class="commonInput"
                                    name="{{ x.id }}"
                                  />

                                  <svg
                                    width="16"
                                    height="17"
                                    viewBox="0 0 24 24"
                                    fill="white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style="cursor: pointer"
                                    (click)="
                                      handlePortsCofficientUpdate($event, x.id)
                                    "
                                  >
                                    <path
                                      d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                      fill="green"
                                    />
                                  </svg>
                                </ng-container>
                              </div>

                              <div
                                *ngIf="!x.isActive()"
                                style="color: #ed1c24; font-size: 19px"
                              >
                                Empty Port
                              </div>
                            </div>
                          </div>

                          <div class="generateCoefficient">
                            <div class="generateCoefficientHeader">
                              Generate Co-Efficient
                            </div>

                            <div class="generateCoefficientContent">
                              <div>Voltage Source:</div>

                              <select
                                style="
                                  width: fit-content;
                                  color: #6a7199;
                                  border: none;
                                  padding-bottom: 6px;
                                  outline: none;
                                  background: transparent;
                                  font-size: 15px;
                                "
                                (change)="
                                  handleGenerateCoefficientVoltageSourceChange(
                                    $event
                                  )
                                "
                              >
                                <option
                                  *ngFor="
                                    let y of generateCofficientVoltageSourceOptions
                                  "
                                  value="{{ y.id }}"
                                  [disabled]="y.disabled"
                                >
                                  {{ y.label }}
                                </option>
                              </select>
                            </div>

                            <div class="generateCoefficientContent">
                              <div>Live Voltage Reading:</div>

                              <div>
                                {{
                                  generateCofficientLiveVoltageReading.toFixed(
                                    3
                                  )
                                }}
                              </div>
                            </div>

                            <div class="generateCoefficientContent">
                              <div>Voltage Reading:</div>

                              <input
                                type="text"
                                value="{{ userVoltageReading }}"
                                (input)="handleUserVoltageReadingChange($event)"
                                class="commonInput"
                                [style.maxWidth]="'100%'"
                              />
                            </div>

                            <div class="generateCoefficientContent">
                              <div>Co-Efficient:</div>
                              <div>{{ calculatedCoEfficient.toFixed(3) }}</div>
                            </div>

                            <button
                              class="generateCoefficientBtn"
                              (click)="handleCalculateCoefficientChange()"
                              [disabled]="
                                !userVoltageReading ||
                                !generateCofficientLiveVoltageReading
                              "
                            >
                              Generate
                            </button>
                          </div>
                        </div>
                      </ng-container>

                      <!--
                    <div
                      style="
                        align-self: stretch;
                        flex: 1 1 0;
                        justify-content: flex-start;
                        align-items: flex-start;
                        gap: 20px;
                        display: inline-flex;
                      "
                    >
                      <div
                        style="
                          width: 360px;
                          align-self: stretch;
                          flex-direction: column;
                          justify-content: flex-start;
                          align-items: flex-start;
                          gap: 12px;
                          display: inline-flex;
                        "
                      >
                        <div
                          style="
                            align-self: stretch;
                            height: 137px;
                            padding: 12px;
                            border-radius: 8px;
                            border: 1px #6285fb solid;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: flex-start;
                            gap: 10px;
                            display: flex;
                          "
                        >
                          <div
                            style="
                              align-self: stretch;
                              justify-content: flex-start;
                              align-items: center;
                              gap: 8px;
                              display: inline-flex;
                            "
                          >
                            <div
                              style="
                                width: 16px;
                                height: 16px;
                                position: relative;
                              "
                            >
                              <input
                                class="sustainergy-radio"
                                (click)="voltageReferenceRadioEdit($event)"
                                [checked]="isVoltageReferenceSource"
                                type="radio"
                                id="voltageReferenceSource"
                              />
                            </div>
                            <div
                              style="
                                color: #0d1758;
                                font-size: 15px;
                                font-weight: 600;
                                word-wrap: break-word;
                              "
                            >
                              Use this gateway:
                            </div>
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              height: 84px;
                              flex-direction: column;
                              justify-content: flex-start;
                              align-items: flex-start;
                              gap: 8px;
                              display: flex;
                            "
                          >
                            <div
                              style="
                                align-self: stretch;
                                height: 38px;
                                padding-left: 24px;
                                flex-direction: column;
                                justify-content: flex-start;
                                align-items: flex-start;
                                gap: 6px;
                                display: flex;
                              "
                            >
                              <div
                                style="
                                  align-self: stretch;
                                  justify-content: flex-start;
                                  align-items: center;
                                  gap: 10px;
                                  display: inline-flex;
                                "
                              >
                                <div
                                  style="
                                    flex: 1 1 0;
                                    flex-direction: column;
                                    justify-content: center;
                                    align-items: flex-start;
                                    gap: 4px;
                                    display: inline-flex;
                                  "
                                >
                                  <div
                                    style="
                                      align-self: stretch;
                                      color: #0d1758;
                                      font-size: 11px;
                                      font-weight: 600;
                                      word-wrap: break-word;
                                    "
                                  >
                                    Voltage Type:
                                  </div>
                                  <div
                                    style="
                                      align-self: stretch;
                                      color: #6e749b;
                                      font-size: 11px;
                                      font-weight: 600;
                                      word-wrap: break-word;
                                    "
                                  >
                                    <select
                                      [ngStyle]="{
                                        'pointer-events':
                                          isVoltageReferenceSource == true
                                            ? 'all'
                                            : 'none'
                                      }"
                                      style="
                                        width: 100%;
                                        color: #6e749b;
                                        border: none;
                                      "
                                      (change)="this.updateVoltageType()"
                                      [(ngModel)]="selectedVoltageType"
                                    >
                                      <option
                                        [ngValue]="null"
                                        disabled
                                      >
                                        Voltage type:
                                      </option>
                                      <option
                                        *ngFor="
                                          let voltageType of voltageTypeList
                                        "
                                        [ngValue]="voltageType.name"
                                      >
                                        {{ voltageType.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div
                                style="
                                  align-self: stretch;
                                  height: 0px;
                                  border: 1px #ece9f1 solid;
                                "
                              ></div>
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                height: 38px;
                                padding-left: 24px;
                                flex-direction: column;
                                justify-content: flex-start;
                                align-items: flex-start;
                                gap: 6px;
                                display: flex;
                              "
                            >
                              <div
                                style="
                                  align-self: stretch;
                                  justify-content: flex-start;
                                  align-items: center;
                                  gap: 10px;
                                  display: inline-flex;
                                "
                              >
                                <div
                                  style="
                                    flex: 1 1 0;
                                    flex-direction: column;
                                    justify-content: center;
                                    align-items: flex-start;
                                    gap: 4px;
                                    display: inline-flex;
                                  "
                                >
                                  <div
                                    style="
                                      align-self: stretch;
                                      color: #0d1758;
                                      font-size: 11px;
                                      font-weight: 600;
                                      word-wrap: break-word;
                                    "
                                  >
                                    Transformer Type:
                                  </div>
                                  <div
                                    style="
                                      align-self: stretch;
                                      color: #6e749b;
                                      font-size: 11px;
                                      font-weight: 600;
                                      word-wrap: break-word;
                                    "
                                  >
                                    <select
                                      [ngStyle]="{
                                        'pointer-events':
                                          isVoltageReferenceSource == true
                                            ? 'all'
                                            : 'none'
                                      }"
                                      style="
                                        width: 100%;
                                        color: #6e749b;
                                        border: none;
                                      "
                                      id="reference_port_2"
                                    >
                                      <option
                                        selected
                                        value="9V"
                                      >
                                        9V Plug in Transformer
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div
                                style="
                                  align-self: stretch;
                                  height: 0px;
                                  border: 1px #ece9f1 solid;
                                "
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div
                          style="
                            align-self: stretch;
                            height: 75px;
                            padding: 12px;
                            border-radius: 8px;
                            border: 1px #ece9f1 solid;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: flex-start;
                            gap: 10px;
                            display: flex;
                          "
                        >
                          <div
                            style="
                              align-self: stretch;
                              justify-content: flex-start;
                              align-items: center;
                              gap: 8px;
                              display: inline-flex;
                            "
                          >
                            <div
                              style="
                                width: 16px;
                                height: 16px;
                                position: relative;
                              "
                            >
                              <input
                                class="sustainergy-radio"
                                (click)="voltageReferenceRadioEdit($event)"
                                [checked]="isVoltageReferenceType"
                                type="radio"
                                id="voltageReferenceType"
                              />
                            </div>
                            <div
                              style="
                                color: #0d1758;
                                font-size: 15px;
                                font-weight: 600;
                                word-wrap: break-word;
                              "
                            >
                              Use another gateway:
                            </div>
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              height: 22px;
                              padding-left: 24px;
                              flex-direction: column;
                              justify-content: flex-start;
                              align-items: flex-start;
                              gap: 6px;
                              display: flex;
                            "
                          >
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 10px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  justify-content: flex-start;
                                  align-items: center;
                                  gap: 6px;
                                  display: flex;
                                "
                              >
                                <div
                                  style="
                                    color: #6e749b;
                                    font-size: 11px;
                                    font-weight: 600;
                                    word-wrap: break-word;
                                  "
                                >
                                  <div
                                    class="pnl-mtr-tab-data-btm-btm-data-table-col"
                                    style="display: block"
                                  >
                                    <select
                                      [ngStyle]="{
                                        'pointer-events':
                                          isVoltageReferenceType == true
                                            ? 'all'
                                            : 'none'
                                      }"
                                      style="
                                        color: #6e749b;
                                        border: none;
                                      "
                                      (change)="
                                        updateVoltageExternalReferencePanel()
                                      "
                                      [(ngModel)]="
                                        selectedvoltageReferencePanel
                                      "
                                    >
                                      <option
                                        [ngValue]="null"
                                        disabled
                                      >
                                        Select Panel
                                      </option>
                                      <option
                                        *ngFor="let panel of panels"
                                        [ngValue]="panel.meter_id"
                                      >
                                        {{ panel.panel_name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                height: 0px;
                                border: 1px #ece9f1 solid;
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div
                        style="
                          flex: 1 1 0;
                          align-self: stretch;
                          padding: 16px;
                          background: #f5f7fb;
                          border-radius: 8px;
                          flex-direction: column;
                          justify-content: flex-start;
                          align-items: flex-start;
                          gap: 16px;
                          display: inline-flex;
                        "
                      >
                        <div
                          style="
                            align-self: stretch;
                            height: 34px;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: flex-start;
                            gap: 12px;
                            display: flex;
                          "
                        >
                          <div
                            style="
                              align-self: stretch;
                              color: #0d1758;
                              font-size: 17px;
                              font-weight: 600;
                              word-wrap: break-word;
                            "
                          >
                            Live Voltage
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              height: 1px;
                              background: #ece9f1;
                            "
                          ></div>
                        </div>
                        <div
                          style="
                            align-self: stretch;
                            height: 91px;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: flex-start;
                            gap: 8px;
                            display: flex;
                          "
                        >
                          <div
                            style="
                              align-self: stretch;
                              justify-content: flex-start;
                              align-items: center;
                              gap: 8px;
                              display: inline-flex;
                            "
                          >
                            <div
                              style="
                                flex: 1 1 0;
                                color: rgba(13, 23, 88, 0.6);
                                font-size: 15px;
                                font-weight: 600;
                                word-wrap: break-word;
                              "
                            >
                              Port V1
                            </div>
                            <div style="text-align: right">
                              <span
                                style="
                                  font-size: 20px;
                                  font-weight: 700;
                                  word-wrap: break-word;
                                "
                                [style.color]="
                                  selectedCurrentCtClamp !== 'null'
                                    ? '#0d1758'
                                    : '#ED1C24'
                                "
                                >{{ voltageSectionList[0] }}</span
                              ><span
                                *ngIf="selectedCurrentCtClamp !== 'null'"
                                style="
                                  color: #0d1758;
                                  font-size: 15px;
                                  font-weight: 700;
                                  word-wrap: break-word;
                                "
                                >V</span
                              >
                            </div>
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              justify-content: flex-start;
                              align-items: center;
                              gap: 8px;
                              display: inline-flex;
                            "
                          >
                            <div
                              style="
                                flex: 1 1 0;
                                color: rgba(13, 23, 88, 0.6);
                                font-size: 15px;
                                font-weight: 600;
                                word-wrap: break-word;
                              "
                            >
                              Port V2
                            </div>
                            <div style="flex: 1 1 0; text-align: right">
                              <span
                                style="
                                  font-size: 20px;
                                  font-weight: 700;
                                  word-wrap: break-word;
                                "
                                [style.color]="
                                  selectedCurrentCtClamp2 !== 'null'
                                    ? '#0d1758'
                                    : '#ED1C24'
                                "
                                >{{ voltageSectionList[1] }}</span
                              ><span
                                *ngIf="selectedCurrentCtClamp2 !== 'null'"
                                style="
                                  color: #0d1758;
                                  font-size: 15px;
                                  font-weight: 700;
                                  word-wrap: break-word;
                                "
                                >V</span
                              >
                            </div>
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              justify-content: flex-start;
                              align-items: center;
                              gap: 8px;
                              display: inline-flex;
                            "
                          >
                            <div
                              style="
                                flex: 1 1 0;
                                color: rgba(13, 23, 88, 0.6);
                                font-size: 15px;
                                font-weight: 600;
                                word-wrap: break-word;
                              "
                            >
                              Port V3
                            </div>
                            <div style="flex: 1 1 0; text-align: right">
                              <span
                                style="
                                  font-size: 20px;
                                  font-weight: 700;
                                  word-wrap: break-word;
                                "
                                [style.color]="
                                  selectedCurrentCtClamp3 !== 'null'
                                    ? '#0d1758'
                                    : '#ED1C24'
                                "
                                >{{ voltageSectionList[2] }}</span
                              ><span
                                *ngIf="selectedCurrentCtClamp3 !== 'null'"
                                style="
                                  color: #0d1758;
                                  font-size: 15px;
                                  font-weight: 700;
                                  word-wrap: break-word;
                                "
                                >V</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> -->
                    </div>
                  </div>

                  <div
                    *ngIf="gateway == '4'"
                    style="
                      width: 100%;
                      height: 466px;
                      padding-top: 24px;
                      background: #f5f5f5;
                      border-top-left-radius: 8px;
                      border-top-right-radius: 8px;
                      border-bottom-right-radius: 8px;
                      overflow: hidden;
                      flex-direction: column;
                      justify-content: flex-start;
                      align-items: flex-start;
                      gap: 18px;
                      display: inline-flex;
                    "
                  >
                    <div
                      style="
                        align-self: stretch;
                        flex: 1 1 0;
                        padding: 20px;
                        background: white;
                        border-radius: 8px;
                        flex-direction: column;
                        justify-content: flex-start;
                        align-items: flex-start;
                        gap: 20px;
                        display: flex;
                      "
                    >
                      <div
                        style="
                          align-self: stretch;
                          height: 40px;
                          flex-direction: column;
                          justify-content: flex-start;
                          align-items: flex-start;
                          gap: 12px;
                          display: flex;
                        "
                      >
                        <div
                          style="
                            align-self: stretch;
                            color: #0d1758;
                            font-size: 22px;
                            font-weight: 700;
                            word-wrap: break-word;
                          "
                        >
                          Current / Amps
                        </div>
                        <div
                          style="
                            align-self: stretch;
                            height: 1px;
                            background: #ece9f1;
                          "
                        ></div>
                      </div>
                      <div
                        style="
                          align-self: stretch;
                          flex: 1 1 0;
                          justify-content: flex-start;
                          align-items: flex-start;
                          gap: 20px;
                          display: inline-flex;
                        "
                      >
                        <div
                          style="
                            flex: 1 1 0;
                            align-self: stretch;
                            padding: 16px;
                            background: #f5f7fb;
                            border-radius: 8px;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: flex-start;
                            gap: 24px;
                            display: inline-flex;
                          "
                        >
                          <div
                            style="
                              align-self: stretch;
                              color: rgba(13, 23, 88, 0.6);
                              font-size: 15px;
                              font-weight: 600;
                              word-wrap: break-word;
                            "
                          >
                            What type of CTs / Flex coils are plugged into the
                            ports?
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              height: 91px;
                              flex-direction: column;
                              justify-content: flex-start;
                              align-items: flex-start;
                              gap: 8px;
                              display: flex;
                            "
                          >
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port I1
                              </div>
                              <div
                                style="
                                  justify-content: flex-start;
                                  align-items: center;
                                  gap: 8px;
                                  display: flex;
                                "
                              >
                                <div style="text-align: right">
                                  <span
                                    style="
                                      color: #0d1758;
                                      font-size: 20px;
                                      font-weight: 700;
                                      word-wrap: break-word;
                                    "
                                  >
                                    <select
                                      style="
                                        width: 60%;
                                        color: #0d1758;
                                        border: none;
                                      "
                                      (change)="this.updateCTType()"
                                      [(ngModel)]="selectedCurrentCtClamp"
                                    >
                                      <option
                                        [ngValue]="null"
                                        disabled
                                      >
                                        CT Clamps:
                                      </option>
                                      <option
                                        *ngFor="
                                          let currentCtClamp of currentCtClamps
                                        "
                                        [ngValue]="currentCtClamp.ct_size"
                                      >
                                        {{ currentCtClamp.ct_size }}
                                      </option>

                                      <option value="null">X</option>
                                    </select>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port I2
                              </div>
                              <div
                                style="
                                  justify-content: flex-start;
                                  align-items: center;
                                  gap: 8px;
                                  display: flex;
                                "
                              >
                                <div style="text-align: right">
                                  <span
                                    style="
                                      color: #0d1758;
                                      font-size: 20px;
                                      font-weight: 700;
                                      word-wrap: break-word;
                                    "
                                  >
                                    <select
                                      style="
                                        width: 60%;
                                        color: #0d1758;
                                        border: none;
                                      "
                                      (change)="this.updateCTType()"
                                      [(ngModel)]="selectedCurrentCtClamp2"
                                    >
                                      <option
                                        [ngValue]="null"
                                        disabled
                                      >
                                        CT Clamps:
                                      </option>
                                      <option
                                        *ngFor="
                                          let currentCtClamp of currentCtClamps
                                        "
                                        [ngValue]="currentCtClamp.ct_size"
                                      >
                                        {{ currentCtClamp.ct_size }}
                                      </option>

                                      <option value="null">X</option>
                                    </select>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port I3
                              </div>
                              <div
                                style="
                                  justify-content: flex-start;
                                  align-items: center;
                                  gap: 8px;
                                  display: flex;
                                "
                              >
                                <div style="text-align: right">
                                  <span
                                    style="
                                      color: #0d1758;
                                      font-size: 20px;
                                      font-weight: 700;
                                      word-wrap: break-word;
                                    "
                                  >
                                    <select
                                      style="
                                        width: 60%;
                                        color: #0d1758;
                                        border: none;
                                      "
                                      (change)="this.updateCTType()"
                                      [(ngModel)]="selectedCurrentCtClamp3"
                                    >
                                      <option
                                        [ngValue]="null"
                                        disabled
                                      >
                                        CT Clamps:
                                      </option>
                                      <option
                                        *ngFor="
                                          let currentCtClamp of currentCtClamps
                                        "
                                        [ngValue]="currentCtClamp.ct_size"
                                      >
                                        {{ currentCtClamp.ct_size }}
                                      </option>

                                      <option value="null">X</option>
                                    </select>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style="
                            flex: 1 1 0;
                            align-self: stretch;
                            padding: 16px;
                            background: #f5f7fb;
                            border-radius: 8px;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: flex-start;
                            gap: 24px;
                            display: inline-flex;
                          "
                        >
                          <div
                            style="
                              align-self: stretch;
                              height: 34px;
                              flex-direction: column;
                              justify-content: flex-start;
                              align-items: flex-start;
                              gap: 12px;
                              display: flex;
                            "
                          >
                            <div
                              style="
                                align-self: stretch;
                                color: #0d1758;
                                font-size: 17px;
                                font-weight: 600;
                                word-wrap: break-word;
                              "
                            >
                              Live Current / Amps
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                height: 1px;
                                background: #ece9f1;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              align-self: stretch;
                              height: 91px;
                              flex-direction: column;
                              justify-content: flex-start;
                              align-items: flex-start;
                              gap: 8px;
                              display: flex;
                            "
                          >
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port I1
                              </div>
                              <div style="text-align: right">
                                <span
                                  style="
                                    font-size: 20px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  [style.color]="
                                    selectedCurrentCtClamp !== 'null'
                                      ? '#0d1758'
                                      : '#ED1C24'
                                  "
                                  >{{ currentSectionList[0] }}</span
                                ><span
                                  *ngIf="selectedCurrentCtClamp !== 'null'"
                                  style="
                                    color: #0d1758;
                                    font-size: 15px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  >A</span
                                >
                              </div>
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port I2
                              </div>
                              <div style="flex: 1 1 0; text-align: right">
                                <span
                                  style="
                                    font-size: 20px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  [style.color]="
                                    selectedCurrentCtClamp2 !== 'null'
                                      ? '#0d1758'
                                      : '#ED1C24'
                                  "
                                  >{{ currentSectionList[1] }}</span
                                ><span
                                  *ngIf="selectedCurrentCtClamp2 !== 'null'"
                                  style="
                                    color: #0d1758;
                                    font-size: 15px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  >A</span
                                >
                              </div>
                            </div>
                            <div
                              style="
                                align-self: stretch;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 8px;
                                display: inline-flex;
                              "
                            >
                              <div
                                style="
                                  flex: 1 1 0;
                                  color: rgba(13, 23, 88, 0.6);
                                  font-size: 15px;
                                  font-weight: 600;
                                  word-wrap: break-word;
                                "
                              >
                                Port I3
                              </div>
                              <div style="flex: 1 1 0; text-align: right">
                                <span
                                  style="
                                    color: #0d1758;
                                    font-size: 20px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  [style.color]="
                                    selectedCurrentCtClamp3 !== 'null'
                                      ? '#0d1758'
                                      : '#ED1C24'
                                  "
                                  >{{ currentSectionList[2] }}</span
                                ><span
                                  *ngIf="selectedCurrentCtClamp3 !== 'null'"
                                  style="
                                    color: #0d1758;
                                    font-size: 15px;
                                    font-weight: 700;
                                    word-wrap: break-word;
                                  "
                                  >A</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div
                  *ngIf="isLoading"
                  class="gatewayContainer"
                >
                  <div class="loaderContainer">
                    <div class="loader"></div>
                  </div>
                </div>
              </div>

              <div
                class="modal-bottom"
                *ngIf="
                  gateway !== '5' &&
                  gateway !== '1' &&
                  gateway !== '3' &&
                  !isLoading
                "
              >
                <div class="modal-bottom-cont">
                  <button
                    class="modal-bottom-edit modal-bottom-btn"
                    (click)="handleEdit()"
                    [ngStyle]="{
                      opacity: editDisabledOpacity,
                      'pointer-events': editDisabled
                    }"
                    type="button"
                  >
                    Edit
                  </button>
                  <button
                    class="modal-bottom-save modal-bottom-btn"
                    [ngStyle]="{
                      opacity: saveDisabledOpacity,
                      'pointer-events': saveDisabled
                    }"
                    (click)="handleMeterSave()"
                    type="button"
                  >
                    Save
                  </button>
                </div>
              </div>
            </ng-template>
          </li>

          <li
            [ngbNavItem]="70"
            class="panel-meter-menu-tabs quick-set-up-tab-txt"
          >
            <a ngbNavLink>Expansions</a>

            <ng-template ngbNavContent>
              <div class="panel-meter-tab-cont meter-data-tab-data">
                <div
                  style="
                    width: 100%;
                    position: relative;
                    border-radius: 12px;
                    background-color: #fff;
                    box-sizing: border-box;
                    padding: 12px 20px;
                    display: grid;
                    grid-auto-flow: column;
                    gap: 40px;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div
                    style="
                      flex: 1;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: flex-start;
                      gap: 20px;
                    "
                  >
                    <svg
                      [ngStyle]="{
                        fill:
                          expansionTitle == 'Live Feed' ? '#6285FB' : '#AFB6CE'
                      }"
                      style="cursor: pointer"
                      (click)="expansionIconClick('Live Feed')"
                      id="frameIcon4"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.4838 10.3449C9.61757 11.2112 9.61757 12.6146 10.4838 13.4851C11.3501 14.3514 12.7534 14.3514 13.624 13.4851C14.4903 12.6189 14.4903 11.2155 13.624 10.3449C12.7534 9.47868 11.3501 9.47868 10.4838 10.3449ZM16.7599 7.20473C16.3268 6.7716 15.6251 6.7716 15.192 7.20473C14.7589 7.63786 14.7589 8.33954 15.192 8.77267C16.9202 10.5052 16.9202 13.3206 15.192 15.0488C14.7589 15.4819 14.7589 16.1836 15.192 16.6167C15.4085 16.8333 15.6944 16.9415 15.976 16.9415C16.2618 16.9415 16.5434 16.8333 16.7599 16.6167C19.3544 14.0266 19.3544 9.80353 16.7599 7.20473ZM8.91156 7.20473C8.47843 6.7716 7.77676 6.7716 7.34363 7.20473C6.08754 8.46082 5.39453 10.1327 5.39453 11.9129C5.39453 13.6931 6.08754 15.3649 7.34363 16.621C7.56019 16.8376 7.84606 16.9459 8.1276 16.9459C8.41346 16.9459 8.695 16.8376 8.91156 16.621C9.3447 16.1879 9.3447 15.4862 8.91156 15.0531C7.17904 13.3206 7.17904 10.5052 8.91156 8.777C9.34903 8.34387 9.34903 7.6422 8.91156 7.20473Z"
                      />
                      <path
                        d="M19.896 4.06899C19.4629 3.63586 18.7612 3.63586 18.3281 4.06899C17.895 4.50212 17.895 5.2038 18.3281 5.63693C21.7888 9.09765 21.7888 14.7284 18.3281 18.1891C17.895 18.6222 17.895 19.3239 18.3281 19.757C18.5447 19.9736 19.32 20.4371 19.896 19.757C23.8419 15.0835 24.223 8.39598 19.896 4.06899ZM5.77593 5.63693C6.20907 5.2038 6.20907 4.50212 5.77593 4.06899C5.3428 3.63586 4.64113 3.63586 4.20799 4.06899C-0.118997 8.39598 -0.0193763 15.3391 4.20799 19.7614C4.80139 20.3851 5.55937 19.9779 5.77593 19.7614C6.20907 19.3282 6.20907 18.6266 5.77593 18.1934C2.31521 14.7284 2.31521 9.09765 5.77593 5.63693Z"
                      />
                    </svg>
                    <svg
                      [ngStyle]="{
                        fill:
                          expansionTitle == 'Mapping' ? '#6285FB' : '#AFB6CE'
                      }"
                      style="cursor: pointer"
                      (click)="expansionIconClick('Mapping')"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.9112 6.37239C17.0684 5.78872 17.3774 5.26271 17.8037 4.85351C18.2299 4.44431 18.7563 4.16815 19.3238 4.0561C19.8912 3.94405 20.4772 4.00055 21.0157 4.21924C21.5543 4.43793 22.024 4.81015 22.3722 5.29401C22.7204 5.77788 22.9332 6.35422 22.9867 6.95819C23.0401 7.56217 22.9321 8.16984 22.6748 8.71285C22.4175 9.25586 22.021 9.71267 21.5301 10.0319C21.0391 10.3512 20.4731 10.5202 19.8958 10.5199C19.2206 10.5196 18.564 10.288 18.0254 9.86036C17.4868 9.43268 17.0956 8.83219 16.9112 8.1499L10.5156 8.1499C10.6758 8.47934 10.7852 8.84195 10.8303 9.22708L11.4642 14.5549C11.5068 14.9133 11.6726 15.2429 11.9304 15.4819C12.1882 15.7209 12.5202 15.8527 12.864 15.8525L13.5273 15.8525C13.6845 15.2688 13.9936 14.7428 14.4198 14.3336C14.846 13.9244 15.3724 13.6482 15.9399 13.5362C16.5073 13.4241 17.0933 13.4806 17.6318 13.6993C18.1704 13.918 18.6402 14.2902 18.9883 14.7741C19.3365 15.258 19.5493 15.8343 19.6028 16.4383C19.6562 17.0422 19.5482 17.6499 19.2909 18.1929C19.0336 18.7359 18.6371 19.1927 18.1462 19.512C17.6552 19.8312 17.0892 20.0002 16.5119 20C15.8367 19.9997 15.1801 19.7681 14.6415 19.3404C14.1029 18.9128 13.7117 18.3123 13.5273 17.63L12.864 17.63C12.1079 17.63 11.3778 17.34 10.811 16.8143C10.2441 16.2886 9.87956 15.5635 9.7858 14.7753L9.15189 9.44749C9.10926 9.0891 8.94346 8.75942 8.68567 8.52046C8.42788 8.2815 8.09587 8.14972 7.75208 8.1499L7.08884 8.1499C6.93164 8.73357 6.62255 9.25958 6.19633 9.66878C5.77012 10.078 5.24369 10.3541 4.67624 10.4662C4.10879 10.5782 3.52284 10.5217 2.98429 10.3031C2.44574 10.0844 1.97595 9.71215 1.62775 9.22828C1.27956 8.74441 1.06677 8.16808 1.01332 7.5641C0.959877 6.96012 1.06789 6.35246 1.32521 5.80945C1.58254 5.26644 1.97897 4.80962 2.46992 4.49038C2.96087 4.17114 3.52686 4.00213 4.10424 4.00237C5.52322 4.00237 6.72 5.00489 7.08884 6.37239L16.9112 6.37239ZM5.5142 7.26115C5.5142 7.45567 5.47773 7.64829 5.40687 7.828C5.33602 8.00772 5.23216 8.17101 5.10123 8.30856C4.97031 8.44611 4.81487 8.55521 4.64381 8.62965C4.47275 8.70409 4.2894 8.74241 4.10424 8.74241C3.91909 8.74241 3.73574 8.70409 3.56468 8.62965C3.39361 8.55521 3.23818 8.44611 3.10725 8.30856C2.97633 8.17101 2.87247 8.00772 2.80161 7.828C2.73076 7.64829 2.69429 7.45567 2.69429 7.26115C2.69429 6.86829 2.84284 6.49153 3.10726 6.21374C3.37167 5.93595 3.7303 5.77988 4.10424 5.77988C4.47819 5.77988 4.83681 5.93595 5.10123 6.21374C5.36565 6.49153 5.5142 6.86829 5.5142 7.26115ZM17.9218 16.7412C17.9218 17.1341 17.7733 17.5108 17.5088 17.7886C17.2444 18.0664 16.8858 18.2225 16.5119 18.2225C16.1379 18.2225 15.7793 18.0664 15.5149 17.7886C15.2505 17.5108 15.1019 17.1341 15.1019 16.7412C15.1019 16.3484 15.2505 15.9716 15.5149 15.6938C15.7793 15.416 16.1379 15.26 16.5119 15.26C16.8858 15.26 17.2444 15.416 17.5088 15.6938C17.7733 15.9716 17.9218 16.3484 17.9218 16.7412ZM21.3057 7.26115C21.3057 7.654 21.1572 8.03077 20.8927 8.30856C20.6283 8.58635 20.2697 8.74241 19.8958 8.74241C19.5218 8.74241 19.1632 8.58635 18.8988 8.30856C18.6343 8.03077 18.4858 7.654 18.4858 7.26115C18.4858 6.86829 18.6343 6.49153 18.8988 6.21374C19.1632 5.93595 19.5218 5.77989 19.8958 5.77989C20.2697 5.77989 20.6283 5.93595 20.8927 6.21374C21.1572 6.49153 21.3057 6.86829 21.3057 7.26115Z"
                      />
                    </svg>
                    <svg
                      [ngStyle]="{
                        fill:
                          expansionTitle == 'Current' ? '#6285FB' : '#AFB6CE'
                      }"
                      style="cursor: pointer"
                      (click)="expansionIconClick('Current')"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.1244 18.0455L14.2486 3.60204C14.0187 3.17965 13.6791 2.82705 13.2657 2.58138C12.8523 2.33572 12.3803 2.20605 11.8994 2.20605C11.4185 2.20605 10.9465 2.33572 10.5331 2.58138C10.1196 2.82705 9.78011 3.17965 9.5502 3.60204L1.67842 18.0447C1.4567 18.4518 1.34456 18.9095 1.35298 19.3729C1.3614 19.8364 1.4901 20.2897 1.72645 20.6885C1.96281 21.0873 2.29872 21.4178 2.70126 21.6477C3.1038 21.8775 3.55915 21.9989 4.0227 21.9998H19.7761C20.2402 21.9997 20.6963 21.8789 21.0997 21.6493C21.503 21.4196 21.8396 21.089 22.0765 20.6898C22.3134 20.2907 22.4424 19.8368 22.4508 19.3728C22.4592 18.9087 22.3467 18.4505 22.1244 18.043V18.0455ZM20.6706 19.8566C20.5803 20.0135 20.4498 20.1434 20.2926 20.2331C20.1353 20.3228 19.9571 20.369 19.7761 20.3669H4.0227C3.84235 20.3667 3.66514 20.3196 3.50845 20.2303C3.35176 20.141 3.22096 20.0125 3.12887 19.8575C3.03678 19.7024 2.98657 19.526 2.98315 19.3457C2.97973 19.1654 3.02322 18.9873 3.10936 18.8288L10.986 4.38864C11.0755 4.22448 11.2075 4.08745 11.3682 3.99198C11.529 3.89651 11.7124 3.84613 11.8994 3.84613C12.0863 3.84613 12.2698 3.89651 12.4306 3.99198C12.5913 4.08745 12.7233 4.22448 12.8127 4.38864L20.6894 18.8288C20.7779 18.9864 20.8229 19.1646 20.8195 19.3453C20.8162 19.5259 20.7648 19.7025 20.6706 19.8566Z"
                      />
                      <path
                        d="M13.535 12.9236H11.472L12.6592 9.95628C12.6991 9.85652 12.7189 9.7499 12.7175 9.64249C12.7161 9.53508 12.6936 9.429 12.6513 9.33029C12.6089 9.23158 12.5475 9.14219 12.4706 9.06721C12.3937 8.99223 12.3027 8.93313 12.203 8.89329C12.1032 8.85346 11.9966 8.83366 11.8892 8.83503C11.7818 8.8364 11.6757 8.85891 11.577 8.90128C11.4783 8.94364 11.3889 9.00504 11.3139 9.08196C11.2389 9.15887 11.1798 9.2498 11.14 9.34956L9.50464 13.4379C9.45507 13.562 9.43666 13.6964 9.45103 13.8292C9.4654 13.9621 9.5121 14.0894 9.58706 14.2C9.66201 14.3106 9.76293 14.4012 9.88099 14.4637C9.99905 14.5263 10.1306 14.559 10.2643 14.559H12.3273L11.14 17.5263C11.1002 17.6261 11.0804 17.7327 11.0817 17.8401C11.0831 17.9475 11.1056 18.0536 11.148 18.1523C11.2335 18.3517 11.3948 18.5089 11.5963 18.5893C11.7977 18.6698 12.0229 18.6669 12.2222 18.5813C12.4216 18.4958 12.5788 18.3345 12.6592 18.1331L14.2946 14.0447C14.3442 13.9206 14.3626 13.7862 14.3482 13.6534C14.3338 13.5205 14.2871 13.3932 14.2122 13.2826C14.1372 13.172 14.0363 13.0814 13.9183 13.0189C13.8002 12.9563 13.6686 12.9236 13.535 12.9236Z"
                      />
                    </svg>
                    <svg
                      [ngStyle]="{
                        fill:
                          expansionTitle == 'Voltage' ? '#6285FB' : '#AFB6CE'
                      }"
                      style="cursor: pointer"
                      (click)="expansionIconClick('Voltage')"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.7046 11.5402C22.5569 11.3867 22.368 11.2789 22.1607 11.2297C21.9533 11.1805 21.7362 11.1919 21.5352 11.2627C21.3341 11.3335 21.1577 11.4606 21.0269 11.6288C20.8961 11.7971 20.8165 11.9994 20.7975 12.2117C20.6725 13.9188 19.0974 17.8878 16.4645 17.8878C12.8766 16.9339 11.9373 2.76719 6.53436 3.00291C2.03713 3.00291 1.16568 8.40052 1.00139 10.7223C0.98691 11.0103 1.08569 11.2924 1.27659 11.5084C1.46749 11.7244 1.73536 11.8571 2.02286 11.8781C2.31036 11.8991 2.59466 11.8067 2.81493 11.6208C3.0352 11.4348 3.17393 11.17 3.20144 10.8831C3.32644 9.17553 3.90181 5.20688 6.53436 5.20688C7.9451 5.20688 10.1026 9.0541 10.9459 11.8652C12.2137 16.0946 13.4138 20.0918 16.4645 20.0918C20.9653 20.0918 22.8332 14.6942 22.9975 12.3724C23.0076 12.2211 22.9869 12.0693 22.9365 11.9262C22.8862 11.7832 22.8073 11.6518 22.7046 11.5402Z"
                      />
                      <path
                        d="M15.1642 12.2617H18.7857C18.9751 12.2617 19.1568 12.1864 19.2908 12.0525C19.4247 11.9185 19.5 11.7368 19.5 11.5474C19.5 11.3579 19.4247 11.1762 19.2908 11.0423C19.1568 10.9083 18.9751 10.8331 18.7857 10.8331H15.1642C14.9748 10.8331 14.7931 10.9083 14.6591 11.0423C14.5252 11.1762 14.4499 11.3579 14.4499 11.5474C14.4499 11.7368 14.5252 11.9185 14.6591 12.0525C14.7931 12.1864 14.9748 12.2617 15.1642 12.2617ZM8.78302 10.8331H5.16188C4.97244 10.8331 4.79075 10.9083 4.65679 11.0423C4.52284 11.1762 4.44758 11.3579 4.44758 11.5474C4.44758 11.7368 4.52284 11.9185 4.65679 12.0525C4.79075 12.1864 4.97244 12.2617 5.16188 12.2617H8.78338C8.97282 12.2617 9.15451 12.1864 9.28847 12.0525C9.42242 11.9185 9.49768 11.7368 9.49768 11.5474C9.49768 11.3579 9.42242 11.1762 9.28847 11.0423C9.15451 10.9083 8.97247 10.8331 8.78302 10.8331Z"
                      />
                    </svg>
                  </div>

                  <div
                    class="selectMeterContainer"
                    *ngIf="data.panel.secondary_panel"
                  >
                    <div
                      class="selectMeterOption"
                      (click)="handleCurrentDialogPanelIdChange('panel_id')"
                      [style.opacity]="
                        selectedPanelKey === 'panel_id' ? 1 : 0.6
                      "
                    >
                      Main Gateway
                    </div>
                    <div class="selectMeterSeparator"></div>
                    <div
                      class="selectMeterOption"
                      (click)="
                        handleCurrentDialogPanelIdChange('secondary_panel')
                      "
                      [style.opacity]="
                        selectedPanelKey === 'secondary_panel' ? 1 : 0.6
                      "
                    >
                      Support Gateway
                    </div>
                  </div>
                </div>

                <div *ngIf="!isLoading">
                  <div class="panel-meter-tab-radio-data">
                    <div class="panel-meter-tab-data-bottom">
                      <div class="panel-meter-tab-data-top-bar">
                        {{ expansionTitle }}
                        <div
                          *ngIf="
                            expansionTitle == 'Mapping' ||
                            expansionTitle == 'Live Feed'
                          "
                          class="panel-meter-tab-data-top-bar-rs"
                        >
                          <div class="panel-meter-tab-data-top-bar-rs-radio">
                            <input
                              id="wattage"
                              type="radio"
                              checked
                              (click)="handlewattageToggle()"
                              name="wattage name"
                            />
                            <label for="wattage">Wattage (w)</label>
                          </div>
                          <div class="panel-meter-tab-data-top-bar-rs-radio">
                            <input
                              id="current-amper"
                              (click)="handlecurrentToggle()"
                              type="radio"
                              name="current amper"
                            />
                            <label for="current-amper"
                              >Current / Amps (a)</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="pnl-mtr-tab-data-bottom-top-cont radio-btn">
                        <div class="pnl-mtr-tab-data-bottom-tp-ls">
                          <p>Expansions</p>
                        </div>
                        <div class="pnl-mtr-tab-data-bottom-tp-rs">
                          <label>
                            <input
                              id="clickA"
                              checked
                              (click)="toggleA()"
                              type="radio"
                              name=""
                            />
                            A
                          </label>
                          <label>
                            <input
                              id="clickB"
                              (click)="toggleB()"
                              type="radio"
                              name=""
                            />
                            B
                          </label>
                          <label>
                            <input
                              id="clickC"
                              (click)="toggleC()"
                              type="radio"
                              name=""
                            />
                            C
                          </label>
                          <label>
                            <input
                              id="clickD"
                              (click)="toggleD()"
                              type="radio"
                              name=""
                            />
                            D
                          </label>
                        </div>
                      </div>
                      <div class="pnl-mtr-tab-data-bottom-btm-cont">
                        <div class="pnl-mtr-tab-data-btm-btm-data">
                          <div class="pnl-mtr-tab-data-btm-btm-data-header">
                            <div class="pnl-mtr-tab-btm-header-col">
                              <p>Expansion <br />Number</p>
                            </div>
                            <div class="pnl-mtr-tab-btm-header-col">
                              <p>
                                Circuit <br />
                                Number
                              </p>
                            </div>
                            <div class="pnl-mtr-tab-btm-header-col">
                              <p>
                                Circuit <br />
                                Name
                              </p>
                            </div>
                            <div class="pnl-mtr-tab-btm-header-col">
                              <p>{{ expansionColumn }}</p>
                            </div>
                            <div class="pnl-mtr-tab-btm-header-col">
                              <p>
                                Expansion <br />
                                Number
                              </p>
                            </div>
                            <div class="pnl-mtr-tab-btm-header-col">
                              <p>Circuit <br />Number</p>
                            </div>
                            <div class="pnl-mtr-tab-btm-header-col">
                              <p>Circuit <br />Name</p>
                            </div>
                            <div class="pnl-mtr-tab-btm-header-col">
                              <p>{{ expansionColumn }}</p>
                            </div>
                          </div>
                          <div class="pnl-mtr-tab-data-btm-btm-data-table">
                            <div
                              class="pnl-mtr-tab-data-btm-btm-data-table-cont"
                            >
                              <!-- here is the Loop Start -->
                              <div
                                *ngIf="userCheckA"
                                class="pnl-mtr-tab-data-btm-btm-data-table-row-carry"
                              >
                                <div
                                  *ngFor="
                                    let expansion of expansion_A;
                                    let i = index
                                  "
                                  class="pnl-mtr-tab-data-btm-btm-data-table-row"
                                  [style.order]="
                                    calculateFlexOrder(i, expansion_A)
                                  "
                                >
                                  <!-- here is the Loop Start -->
                                  <div
                                    class="table-expansion-number pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <p>{{ expansion.expansion_number }}</p>
                                  </div>
                                  <div
                                    class="table-circuit-number pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <input
                                      type="text"
                                      id="{{ expansion.expansion_number }}"
                                      class="circuit-number-txt
                                    {{ expansion.id }}"
                                      (keydown)="editEnabled()"
                                      (keyup.enter)="
                                        updateCircuit(
                                          expansion.expansion_number,
                                          expansion.id,
                                          expansion.voltage_reference
                                        )
                                      "
                                      name="{{ expansion.voltage_reference }}"
                                      value="{{
                                        expansion.circuit_number || 'X'
                                      }}"
                                      [ngStyle]="{
                                        border:
                                          expansionEditAllowed &&
                                          expansionTitle == 'Mapping'
                                            ? ''
                                            : 'none',
                                        'pointer-events':
                                          expansionEditAllowed &&
                                          expansionTitle == 'Mapping'
                                            ? ''
                                            : 'none',
                                        color:
                                          !expansion.circuit_number &&
                                          !expansionEditAllowed
                                            ? '#ED1C24'
                                            : ''
                                      }"
                                    />
                                    <div
                                      *ngIf="expansion.circuit_number"
                                      class="circuit-color"
                                      [ngStyle]="{
                                        'background-color': expansion.colour
                                      }"
                                    ></div>
                                  </div>
                                  <div
                                    class="table-circuit-name pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <p
                                      [style.color]="
                                        !expansion.circuit_number && '#ED1C24'
                                      "
                                    >
                                      {{
                                        !expansion.circuit_number
                                          ? 'Empty Port'
                                          : expansion.circuit_name
                                      }}
                                    </p>
                                  </div>

                                  <ng-container
                                    *ngIf="!expansion.circuit_number"
                                  >
                                    <div
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                      style="color: #ed1c24; font-size: 0.733vw"
                                    >
                                      X
                                    </div>
                                  </ng-container>

                                  <ng-container
                                    *ngIf="expansion.circuit_number.length > 0"
                                  >
                                    <div
                                      *ngIf="
                                        expansionTitle == 'Mapping' ||
                                        expansionTitle == 'Live Feed'
                                      "
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <p>
                                        {{
                                          wattageFlag
                                            ? expansion.watts
                                            : expansion.amps
                                        }}
                                      </p>
                                    </div>

                                    <div
                                      *ngIf="expansionTitle == 'Voltage'"
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <select
                                        class="selectdropDownValue"
                                        name="{{ expansion.expansion_number }}"
                                        (ngModelChange)="
                                          selectRowChange(
                                            $event,
                                            expansion.expansion_number,
                                            expansion.id,
                                            expansion.current_ct_clamp
                                          )
                                        "
                                        [ngStyle]="{
                                          'pointer-events': dropdownDisabled
                                        }"
                                        [(ngModel)]="
                                          !expansion.circuit_number
                                            ? ''
                                            : expansion.voltage_reference
                                        "
                                      >
                                        <option value="V1">V1</option>
                                        <option value="V2">V2</option>
                                        <option value="V3">V3</option>
                                      </select>
                                    </div>

                                    <div
                                      *ngIf="expansionTitle == 'Current'"
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <select
                                        class="selectdropDownValue"
                                        name="{{ expansion.expansion_number }}"
                                        (ngModelChange)="
                                          selectRowChange(
                                            expansion.voltage_refrence_type,
                                            expansion.expansion_number,
                                            expansion.id,
                                            $event
                                          )
                                        "
                                        [ngStyle]="{
                                          'pointer-events': dropdownDisabled
                                        }"
                                        [(ngModel)]="expansion.current_ct_clamp"
                                      >
                                        <option
                                          *ngFor="
                                            let currentCtClamp of currentCtClamps
                                          "
                                          [ngValue]="currentCtClamp.ct_size"
                                        >
                                          {{ currentCtClamp.ct_size }}
                                        </option>
                                      </select>
                                    </div>
                                  </ng-container>
                                </div>
                              </div>

                              <div
                                *ngIf="userCheckB"
                                class="pnl-mtr-tab-data-btm-btm-data-table-row-carry"
                              >
                                <div
                                  *ngFor="
                                    let expansion of expansion_B;
                                    let i = index
                                  "
                                  class="pnl-mtr-tab-data-btm-btm-data-table-row"
                                  [style.order]="
                                    calculateFlexOrder(i, expansion_B)
                                  "
                                >
                                  <div
                                    class="table-expansion-number pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <p>{{ expansion.expansion_number }}</p>
                                  </div>
                                  <div
                                    class="table-circuit-number pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <input
                                      type="text"
                                      id="{{ expansion.expansion_number }}"
                                      class="circuit-number-txt {{
                                        expansion.id
                                      }}"
                                      (keydown)="editEnabled()"
                                      (keyup.enter)="
                                        updateCircuit(
                                          expansion.expansion_number,
                                          expansion.id,
                                          expansion.voltage_reference
                                        )
                                      "
                                      name="{{ expansion.voltage_reference }}"
                                      value="{{
                                        expansion.circuit_number || 'X'
                                      }}"
                                      [ngStyle]="{
                                        border:
                                          expansionEditAllowed &&
                                          expansionTitle == 'Mapping'
                                            ? ''
                                            : 'none',
                                        'pointer-events':
                                          expansionEditAllowed &&
                                          expansionTitle == 'Mapping'
                                            ? ''
                                            : 'none',
                                        color:
                                          !expansion.circuit_number &&
                                          !expansionEditAllowed
                                            ? '#ED1C24'
                                            : ''
                                      }"
                                    />
                                    <div
                                      *ngIf="expansion.circuit_number"
                                      class="circuit-color"
                                      [ngStyle]="{
                                        'background-color': expansion.colour
                                      }"
                                    ></div>
                                  </div>

                                  <div
                                    class="table-circuit-name pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <p
                                      [ngStyle]="
                                        !expansion.circuit_number
                                          ? {
                                              color: '#ED1C24',
                                              'font-size': '0.6vw'
                                            }
                                          : null
                                      "
                                    >
                                      {{
                                        !expansion.circuit_number
                                          ? 'Empty Port'
                                          : expansion.circuit_name
                                      }}
                                    </p>
                                  </div>

                                  <ng-container
                                    *ngIf="!expansion.circuit_number"
                                  >
                                    <div
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                      style="color: #ed1c24; font-size: 0.733vw"
                                    >
                                      X
                                    </div>
                                  </ng-container>

                                  <ng-container
                                    *ngIf="expansion.circuit_number.length > 0"
                                  >
                                    <div
                                      *ngIf="
                                        expansionTitle == 'Mapping' ||
                                        expansionTitle == 'Live Feed'
                                      "
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <p>
                                        {{
                                          wattageFlag
                                            ? expansion.watts
                                            : expansion.amps
                                        }}
                                      </p>
                                    </div>

                                    <div
                                      *ngIf="expansionTitle == 'Voltage'"
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <select
                                        class="selectdropDownValue"
                                        name="{{ expansion.expansion_number }}"
                                        (ngModelChange)="
                                          selectRowChange(
                                            $event,
                                            expansion.expansion_number,
                                            expansion.id,
                                            expansion.current_ct_clamp
                                          )
                                        "
                                        [ngStyle]="{
                                          'pointer-events': dropdownDisabled
                                        }"
                                        [(ngModel)]="
                                          expansion.voltage_reference
                                        "
                                      >
                                        <option value="V1">V1</option>
                                        <option value="V2">V2</option>
                                        <option value="V3">V3</option>
                                      </select>
                                    </div>

                                    <div
                                      *ngIf="expansionTitle == 'Current'"
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <select
                                        class="selectdropDownValue"
                                        name="{{ expansion.expansion_number }}"
                                        (ngModelChange)="
                                          selectRowChange(
                                            expansion.voltage_refrence_type,
                                            expansion.expansion_number,
                                            expansion.id,
                                            $event
                                          )
                                        "
                                        [ngStyle]="{
                                          'pointer-events': dropdownDisabled
                                        }"
                                        [(ngModel)]="expansion.current_ct_clamp"
                                      >
                                        <option
                                          *ngFor="
                                            let currentCtClamp of currentCtClamps
                                          "
                                          [ngValue]="currentCtClamp.ct_size"
                                        >
                                          {{ currentCtClamp.ct_size }}
                                        </option>
                                      </select>
                                    </div>
                                  </ng-container>
                                </div>
                              </div>

                              <div
                                *ngIf="userCheckC"
                                class="pnl-mtr-tab-data-btm-btm-data-table-row-carry"
                              >
                                <div
                                  *ngFor="
                                    let expansion of expansion_C;
                                    let i = index
                                  "
                                  class="pnl-mtr-tab-data-btm-btm-data-table-row"
                                  [style.order]="
                                    calculateFlexOrder(i, expansion_C)
                                  "
                                >
                                  <div
                                    class="table-expansion-number pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <p>{{ expansion.expansion_number }}</p>
                                  </div>
                                  <div
                                    class="table-circuit-number pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <input
                                      type="text"
                                      id="{{ expansion.expansion_number }}"
                                      class="circuit-number-txt {{
                                        expansion.id
                                      }}"
                                      (keydown)="editEnabled()"
                                      (keyup.enter)="
                                        updateCircuit(
                                          expansion.expansion_number,
                                          expansion.id,
                                          expansion.voltage_reference
                                        )
                                      "
                                      name="{{ expansion.voltage_reference }}"
                                      value="{{
                                        expansion.circuit_number || 'X'
                                      }}"
                                      [ngStyle]="{
                                        border:
                                          expansionEditAllowed &&
                                          expansionTitle == 'Mapping'
                                            ? ''
                                            : 'none',
                                        'pointer-events':
                                          expansionEditAllowed &&
                                          expansionTitle == 'Mapping'
                                            ? ''
                                            : 'none',
                                        color:
                                          !expansion.circuit_number &&
                                          !expansionEditAllowed
                                            ? '#ED1C24'
                                            : ''
                                      }"
                                    />
                                    <div
                                      *ngIf="expansion.circuit_number"
                                      class="circuit-color"
                                      [ngStyle]="{
                                        'background-color': expansion.colour
                                      }"
                                    ></div>
                                  </div>

                                  <div
                                    class="table-circuit-name pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <p
                                      [ngStyle]="
                                        !expansion.circuit_number
                                          ? {
                                              color: '#ED1C24',
                                              'font-size': '0.6vw'
                                            }
                                          : null
                                      "
                                    >
                                      {{
                                        !expansion.circuit_number
                                          ? 'Empty Port'
                                          : expansion.circuit_name
                                      }}
                                    </p>
                                  </div>

                                  <ng-container
                                    *ngIf="!expansion.circuit_number"
                                  >
                                    <div
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                      style="color: #ed1c24; font-size: 0.733vw"
                                    >
                                      X
                                    </div>
                                  </ng-container>

                                  <ng-container
                                    *ngIf="expansion.circuit_number.length > 0"
                                  >
                                    <div
                                      *ngIf="
                                        expansionTitle == 'Mapping' ||
                                        expansionTitle == 'Live Feed'
                                      "
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <p>
                                        {{
                                          wattageFlag
                                            ? expansion.watts
                                            : expansion.amps
                                        }}
                                      </p>
                                    </div>

                                    <div
                                      *ngIf="expansionTitle == 'Voltage'"
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <select
                                        class="selectdropDownValue"
                                        name="{{ expansion.expansion_number }}"
                                        (ngModelChange)="
                                          selectRowChange(
                                            $event,
                                            expansion.expansion_number,
                                            expansion.id,
                                            expansion.current_ct_clamp
                                          )
                                        "
                                        [ngStyle]="{
                                          'pointer-events': dropdownDisabled
                                        }"
                                        [(ngModel)]="
                                          expansion.voltage_reference
                                        "
                                      >
                                        <option value="V1">V1</option>
                                        <option value="V2">V2</option>
                                        <option value="V3">V3</option>
                                      </select>
                                    </div>

                                    <div
                                      *ngIf="expansionTitle == 'Current'"
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <select
                                        class="selectdropDownValue"
                                        name="{{ expansion.expansion_number }}"
                                        (ngModelChange)="
                                          selectRowChange(
                                            expansion.voltage_refrence_type,
                                            expansion.expansion_number,
                                            expansion.id,
                                            $event
                                          )
                                        "
                                        [ngStyle]="{
                                          'pointer-events': dropdownDisabled
                                        }"
                                        [(ngModel)]="expansion.current_ct_clamp"
                                      >
                                        <option
                                          *ngFor="
                                            let currentCtClamp of currentCtClamps
                                          "
                                          [ngValue]="currentCtClamp.ct_size"
                                        >
                                          {{ currentCtClamp.ct_size }}
                                        </option>
                                      </select>
                                    </div>
                                  </ng-container>
                                </div>
                              </div>

                              <div
                                *ngIf="userCheckD"
                                class="pnl-mtr-tab-data-btm-btm-data-table-row-carry"
                              >
                                <div
                                  *ngFor="
                                    let expansion of expansion_D;
                                    let i = index
                                  "
                                  class="pnl-mtr-tab-data-btm-btm-data-table-row"
                                  [style.order]="
                                    calculateFlexOrder(i, expansion_D)
                                  "
                                >
                                  <div
                                    class="table-expansion-number pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <p>{{ expansion.expansion_number }}</p>
                                  </div>
                                  <div
                                    class="table-circuit-number pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <input
                                      type="text"
                                      id="{{ expansion.expansion_number }}"
                                      class="circuit-number-txt {{
                                        expansion.id
                                      }}"
                                      (keydown)="editEnabled()"
                                      (keyup.enter)="
                                        updateCircuit(
                                          expansion.expansion_number,
                                          expansion.id,
                                          expansion.voltage_reference
                                        )
                                      "
                                      name="{{ expansion.voltage_reference }}"
                                      value="{{
                                        expansion.circuit_number || 'X'
                                      }}"
                                      [ngStyle]="{
                                        border:
                                          expansionEditAllowed &&
                                          expansionTitle == 'Mapping'
                                            ? ''
                                            : 'none',
                                        'pointer-events':
                                          expansionEditAllowed &&
                                          expansionTitle == 'Mapping'
                                            ? ''
                                            : 'none',
                                        color:
                                          !expansion.circuit_number &&
                                          !expansionEditAllowed
                                            ? '#ED1C24'
                                            : ''
                                      }"
                                    />
                                    <div
                                      *ngIf="expansion.circuit_number"
                                      class="circuit-color"
                                      [ngStyle]="{
                                        'background-color': expansion.colour
                                      }"
                                    ></div>
                                  </div>
                                  <div
                                    class="table-circuit-name pnl-mtr-tab-data-btm-btm-data-table-col"
                                  >
                                    <p
                                      [ngStyle]="
                                        !expansion.circuit_number
                                          ? {
                                              color: '#ED1C24',
                                              'font-size': '0.6vw'
                                            }
                                          : null
                                      "
                                    >
                                      {{
                                        !expansion.circuit_number
                                          ? 'Empty Port'
                                          : expansion.circuit_name
                                      }}
                                    </p>
                                  </div>

                                  <ng-container
                                    *ngIf="!expansion.circuit_number"
                                  >
                                    <div
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                      style="color: #ed1c24; font-size: 0.733vw"
                                    >
                                      X
                                    </div>
                                  </ng-container>

                                  <ng-container
                                    *ngIf="expansion.circuit_number.length > 0"
                                  >
                                    <div
                                      *ngIf="
                                        expansionTitle == 'Mapping' ||
                                        expansionTitle == 'Live Feed'
                                      "
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <p>
                                        {{
                                          wattageFlag
                                            ? expansion.watts
                                            : expansion.amps
                                        }}
                                      </p>
                                    </div>

                                    <div
                                      *ngIf="expansionTitle == 'Voltage'"
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <select
                                        class="selectdropDownValue"
                                        name="{{ expansion.expansion_number }}"
                                        (ngModelChange)="
                                          selectRowChange(
                                            $event,
                                            expansion.expansion_number,
                                            expansion.id,
                                            expansion.current_ct_clamp
                                          )
                                        "
                                        [ngStyle]="{
                                          'pointer-events': dropdownDisabled
                                        }"
                                        [(ngModel)]="
                                          expansion.voltage_reference
                                        "
                                      >
                                        <option value="V1">V1</option>
                                        <option value="V2">V2</option>
                                        <option value="V3">V3</option>
                                      </select>
                                    </div>

                                    <div
                                      *ngIf="expansionTitle == 'Current'"
                                      class="table-watts pnl-mtr-tab-data-btm-btm-data-table-col"
                                    >
                                      <select
                                        class="selectdropDownValue"
                                        name="{{ expansion.expansion_number }}"
                                        (ngModelChange)="
                                          selectRowChange(
                                            expansion.voltage_refrence_type,
                                            expansion.expansion_number,
                                            expansion.id,
                                            $event
                                          )
                                        "
                                        [ngStyle]="{
                                          'pointer-events': dropdownDisabled
                                        }"
                                        [(ngModel)]="expansion.current_ct_clamp"
                                      >
                                        <option
                                          *ngFor="
                                            let currentCtClamp of currentCtClamps
                                          "
                                          [ngValue]="currentCtClamp.ct_size"
                                        >
                                          {{ currentCtClamp.ct_size }}
                                        </option>
                                      </select>
                                    </div>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="isLoading"
                  class="gatewayContainer"
                >
                  <div class="loaderContainer">
                    <div class="loader"></div>
                  </div>
                </div>
              </div>

              <div
                class="modal-bottom"
                *ngIf="expansionTitle !== 'Live Feed' && !isLoading"
              >
                <div class="modal-bottom-cont">
                  <button
                    class="modal-bottom-edit modal-bottom-btn"
                    (click)="handleEdit()"
                    [ngStyle]="{
                      opacity: editDisabledOpacity,
                      'pointer-events': editDisabled
                    }"
                    type="button"
                  >
                    Edit
                  </button>
                  <button
                    class="modal-bottom-save modal-bottom-btn"
                    [ngStyle]="{
                      opacity: saveDisabledOpacity,
                      'pointer-events': saveDisabled
                    }"
                    (click)="handleSave()"
                    type="button"
                  >
                    Save
                  </button>
                </div>
              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>
      </div>
    </div>
  </div>
</div>
